import { StreetFoodQuest } from '../types';
export const STREET_FOOD_CONFIGS: Record<string, {
  standName: string;
  standIcon: string;
  cuisine: string;
  quests: StreetFoodQuest[];
}> = {
  'SEOUL': {
    standName: 'Tteokbokki Stand',
    standIcon: 'ChefHat',
    cuisine: 'Korean',
    quests: [
      {
        id: 'tteokbokki_master',
        name: 'Tteokbokki Master Challenge',
        description: 'Eat spicy rice cakes without crying. The ultimate Korean street food test!',
        location: 'Dongdaemoon Food Alley',
        reward: 50000,
        fanReward: 15000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tteokbokki_main',
            name: 'Street Tteokbokki',
            emoji: '🌶️',
            calories: 350,
            protein: 9,
            carbs: 50,
            fat: 10,
            description: 'Chewy rice cakes in a spicy-sweet gochujang sauce. The quintessential Korean street food.',
            ingredients: ['Tteok (rice cakes)', 'Gochujang', 'Fish cakes (eomuk)', 'Green onions'],
            allergens: ['Fish', 'Soy', 'Wheat'],
            cookingMethod: 'Simmered in spicy broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/a/ac/Ganjang-tteok-bokki.jpg'
          }
        ]
      },
      {
        id: 'korean_corn_dog',
        name: 'Korean Corn Dog Adventure',
        description: 'Enjoy a crispy, sugar-coated Korean corn dog. Popular with idols!',
        location: 'Myeongdong Street',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'corndog_main',
            name: 'Korean Corn Dog',
            emoji: '🌭',
            calories: 330,
            protein: 10,
            carbs: 40,
            fat: 14,
            description: 'Crispy battered hot dog coated in sugar and condiments.',
            ingredients: ['Sausage', 'Yeast dough', 'Breadcrumbs', 'Sugar', 'Ketchup', 'Mustard'],
            allergens: ['Gluten', 'Eggs', 'Dairy'],
            cookingMethod: 'Deep-fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Korean_corn_dog_%26_fried_dumplings_-_KOGI_to-go_Korean_kitchen.jpg'
          }
        ]
      },
      {
        id: 'bunggeoppang_fish',
        name: 'Bunggeoppang Fish Bread',
        description: 'Find the perfect fish-shaped pastry. Warm, sweet, and Instagram-worthy!',
        location: 'Insadong Traditional Market',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'bunggeoppang_main',
            name: 'Bunggeoppang',
            emoji: '🐟',
            calories: 220,
            protein: 6,
            carbs: 38,
            fat: 8,
            description: 'Fish-shaped pastry filled with sweet red bean paste.',
            ingredients: ['Wheat flour', 'Red bean paste', 'Sugar', 'Milk', 'Eggs'],
            allergens: ['Gluten', 'Eggs', 'Dairy'],
            cookingMethod: 'Baked in a mold',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/28/Bungeoppang-01.jpg'
          }
        ]
      },
      {
        id: 'eomuk_fishcake',
        name: 'Eomuk Fishcake Skewers',
        description: 'Enjoy hot fishcake skewers in savory broth. The ultimate winter comfort food!',
        location: 'N Seoul Mountain Entrance',
        reward: 22000,
        fanReward: 7000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'eomuk_main',
            name: 'Eomuk Skewer',
            emoji: '🍢',
            calories: 140,
            protein: 10,
            carbs: 15,
            fat: 4,
            description: 'Folded fish cake skewer served with warm, savory broth.',
            ingredients: ['Fish paste', 'Flour', 'Vegetables', 'Anchovy broth', 'Soy sauce'],
            allergens: ['Fish', 'Soy', 'Wheat'],
            cookingMethod: 'Boiled in broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/10/2020-03-11_12.25.07_%EB%B6%84%EC%8B%9D%EC%A7%91_%EC%98%A4%EB%8E%85.jpg'
          }
        ]
      },
      {
        id: 'hotteok_sweet_pancake',
        name: 'Hotteok Sweet Pancake',
        description: 'Find the perfect hotteok - sweet pancakes filled with brown sugar and nuts.',
        location: 'Myeongdong Shopping District',
        reward: 45000,
        fanReward: 14000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'hotteok_main',
            name: 'Sweet Hotteok',
            emoji: '🥞',
            calories: 290,
            protein: 5,
            carbs: 58,
            fat: 7,
            description: 'Fried pancake filled with melted brown sugar, cinnamon, and nuts.',
            ingredients: ['Wheat flour', 'Brown sugar', 'Cinnamon', 'Peanuts', 'Yeast'],
            allergens: ['Gluten', 'Nuts', 'Sesame'],
            cookingMethod: 'Pan-fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Hotteok_-_Korean_Sweet_Pancake.jpg'
          }
        ]
      },
      {
        id: 'kimchi_banchan_exploration',
        name: 'Kimchi & Banchan Side Quest',
        description: 'Sample authentic kimchi. A staple of every Korean meal!',
        location: 'Traditional Korean Restaurant',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kimchi_main',
            name: 'Kimchi & Banchan',
            emoji: '🥬',
            calories: 45,
            protein: 3,
            carbs: 8,
            fat: 1,
            description: 'Spicy fermented napa cabbage served with small side dishes.',
            ingredients: ['Napa cabbage', 'Gochugaru (chili powder)', 'Garlic', 'Ginger', 'Fish sauce'],
            allergens: ['Fish', 'Shellfish'],
            cookingMethod: 'Fermented',
            image: 'https://upload.wikimedia.org/wikipedia/commons/b/b3/Kimchi_(25691001490).jpg'
          }
        ]
      }
    ]
  },
  'TOKYO': {
    standName: 'Takoyaki Stand',
    standIcon: 'Utensils',
    cuisine: 'Japanese',
    quests: [
      {
        id: 'takoyaki_master',
        name: 'Takoyaki Ball Challenge',
        description: 'Eat 12 octopus balls while they\'re perfectly hot and crispy. Don\'t burn your tongue!',
        location: 'Dotonbori Street',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'takoyaki_main',
            name: 'Classic Takoyaki',
            emoji: '🐙',
            calories: 220,
            protein: 8,
            carbs: 25,
            fat: 10,
            description: 'Octopus-filled dough balls topped with takoyaki sauce, mayo, and bonito flakes.',
            ingredients: ['Wheat flour', 'Octopus', 'Green onions', 'Pickled ginger', 'Takoyaki sauce', 'Bonito flakes'],
            allergens: ['Gluten', 'Shellfish', 'Fish', 'Eggs'],
            cookingMethod: 'Grilled in spherical molds',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8f/A_Takoyaki.jpg'
          }
        ]
      },
      {
        id: 'ramen_street',
        name: 'Street Ramen Adventure',
        description: 'Slurp a hot bowl of traditional ramen from a street cart. Soul food!',
        location: 'Shibuya Ramen Street',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'ramen_main',
            name: 'Shoyu Ramen',
            emoji: '🍜',
            calories: 450,
            protein: 20,
            carbs: 50,
            fat: 15,
            description: 'Soy sauce based broth with curly noodles, chashu pork, and bamboo shoots.',
            ingredients: ['Wheat noodles', 'Chicken/Pork broth', 'Soy sauce', 'Chashu pork', 'Menma', 'Green onions'],
            allergens: ['Gluten', 'Soy', 'Eggs', 'Pork'],
            cookingMethod: 'Simmered broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/2013.02.27.ramen.jpg'
          }
        ]
      },
      {
        id: 'taiyaki_fish',
        name: 'Taiyaki Sweet Fish',
        description: 'Enjoy a warm fish-shaped cake filled with sweet red bean paste or custard.',
        location: 'Asakusa Market',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'taiyaki_main',
            name: 'Taiyaki',
            emoji: '🐠',
            calories: 200,
            protein: 5,
            carbs: 35,
            fat: 7,
            description: 'Classic fish-shaped cake with sweet filling.',
            ingredients: ['Wheat flour', 'Sugar', 'Milk', 'Eggs', 'Red bean paste (Azuki)'],
            allergens: ['Gluten', 'Eggs', 'Dairy'],
            cookingMethod: 'Baked in iron mold',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Taiyaki_at_Kyoto_station.jpg'
          }
        ]
      }
    ]
  },
  'BEIJING': {
    standName: 'Jianbing Stand',
    standIcon: 'Cookie',
    cuisine: 'Chinese',
    quests: [
      {
        id: 'jianbing_breakfast',
        name: 'Jianbing Breakfast',
        description: 'The ultimate Chinese street breakfast. Savory crepe with egg and crispy cracker.',
        location: 'Hutong Breakfast Alley',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'jianbing_main',
            name: 'Jianbing Guozi',
            emoji: '🥞',
            calories: 300,
            protein: 10,
            carbs: 40,
            fat: 12,
            description: 'Savory crepe with egg, scallions, cilantro, and crispy fried cracker (baocui).',
            ingredients: ['Flour dough', 'Eggs', 'Scallions', 'Cilantro', 'Sweet bean sauce', 'Chili paste', 'Baocui (cracker)'],
            allergens: ['Wheat', 'Eggs', 'Soy'],
            cookingMethod: 'Griddled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/b/b5/Crepes.jpg'
          }
        ]
      },
      {
        id: 'baozi_steamed',
        name: 'Baozi Steamed Bun',
        description: 'Soft and fluffy steamed buns with savory fillings. Careful, they\'re hot!',
        location: 'Wangfujing Street Food',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'baozi_main',
            name: 'Steamed Baozi',
            emoji: '🥟',
            calories: 220,
            protein: 8,
            carbs: 30,
            fat: 8,
            description: 'Fluffy white bun filled with juicy pork and scallions.',
            ingredients: ['Wheat flour', 'Pork', 'Scallions', 'Ginger', 'Soy sauce', 'Sesame oil', 'Yeast'],
            allergens: ['Gluten', 'Soy', 'Pork'],
            cookingMethod: 'Steamed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9f/Bao_buns.jpg'
          }
        ]
      }
    ]
  },
  'BANGKOK': {
    standName: 'Pad Thai Cart',
    standIcon: 'Star',
    cuisine: 'Thai',
    quests: [
      {
        id: 'pad_thai_street',
        name: 'Street Pad Thai',
        description: 'Wok-fried rice noodles with the perfect balance of sweet, sour, and salty flavors.',
        location: 'Chatuchak Market',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'padthai_main',
            name: 'Pad Thai Goong',
            emoji: '🍜',
            calories: 400,
            protein: 15,
            carbs: 50,
            fat: 12,
            description: 'Stir-fried rice noodles with shrimp, tofu, peanuts, and bean sprouts.',
            ingredients: ['Rice noodles', 'Shrimp', 'Tofu', 'Peanuts', 'Bean sprouts', 'Egg', 'Tamarind sauce', 'Fish sauce'],
            allergens: ['Shellfish', 'Peanuts', 'Soy', 'Eggs', 'Fish'],
            cookingMethod: 'Wok-fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/e/ed/Pad_Thai.JPG'
          }
        ]
      },
      {
        id: 'mango_sticky_rice',
        name: 'Mango Sticky Rice',
        description: 'Sweet ripe mango with warm coconut sticky rice. The perfect dessert!',
        location: 'Sukhumvit Street Stalls',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mangosticky_main',
            name: 'Mango Sticky Rice',
            emoji: '🥭',
            calories: 350,
            protein: 4,
            carbs: 65,
            fat: 10,
            description: 'Glutinous rice cooked with coconut milk, served with fresh mango slices.',
            ingredients: ['Glutinous rice', 'Coconut milk', 'Mango', 'Sugar', 'Salt', 'Mung beans'],
            allergens: [],
            cookingMethod: 'Steamed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/0a/Som_tam_thai.JPG'
          }
        ]
      }
    ]
  },
  'MEXICO_CITY': {
    standName: 'Taco Stand',
    standIcon: 'Heart',
    cuisine: 'Mexican',
    quests: [
      {
        id: 'taco_al_pastor',
        name: 'Taco al Pastor Master',
        description: 'Master the art of eating marinated pork tacos with pineapple. The ultimate Mexican street food!',
        location: 'La Merced Market',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'taco_main',
            name: 'Tacos al Pastor',
            emoji: '🌮',
            calories: 300,
            protein: 18,
            carbs: 24,
            fat: 14,
            description: 'Corn tortillas filled with spit-roasted marinated pork, pineapple, onion, and cilantro.',
            ingredients: ['Pork shoulder', 'Corn tortillas', 'Pineapple', 'Onion', 'Cilantro', 'Achiote paste'],
            allergens: ['Pork'],
            cookingMethod: 'Vertical rotisserie (Trompo)',
            image: 'https://upload.wikimedia.org/wikipedia/commons/b/bd/Trompo_de_tacos_al_pastor.jpg'
          }
        ]
      },
      {
        id: 'elote_street',
        name: 'Street Elote Adventure',
        description: 'Enjoy a warm corn cob slathered in mayo, cheese, and chili powder.',
        location: 'Condesa Street Food Park',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'elote_main',
            name: 'Mexican Street Corn (Elote)',
            emoji: '🌽',
            calories: 250,
            protein: 8,
            carbs: 30,
            fat: 12,
            description: 'Grilled corn on the cob covered in mayonnaise, cotija cheese, lime, and chili powder.',
            ingredients: ['Corn on cob', 'Mayonnaise', 'Cotija cheese', 'Chili powder', 'Lime juice'],
            allergens: ['Dairy', 'Eggs'],
            cookingMethod: 'Grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/df/Elote_con_crema_y_queso_cotija.jpg'
          }
        ]
      }
    ]
  },
  'OSAKA': {
    standName: 'Osaka Food Court',
    standIcon: 'ChefHat',
    cuisine: 'Japanese',
    quests: [
      {
        id: 'osaka_okonomiyaki',
        name: 'Okonomiyaki Master',
        description: 'Try the savory Japanese pancakes that Osaka is famous for!',
        location: 'Dotonbori',
        reward: 48000,
        fanReward: 14000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'okonomiyaki_main',
            name: 'Osaka Okonomiyaki',
            emoji: '🥞',
            calories: 450,
            protein: 20,
            carbs: 55,
            fat: 18,
            description: 'Savory cabbage pancake topped with pork belly, sauce, mayo, and condiments.',
            ingredients: ['Cabbage', 'Flour batter', 'Eggs', 'Pork belly', 'Okonomiyaki sauce', 'Japanese mayo', 'Bonito flakes'],
            allergens: ['Gluten', 'Eggs', 'Pork', 'Fish', 'Soy'],
            cookingMethod: 'Teppan grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/5/5f/Okonomiyaki_in_Osaka.JPG'
          }
        ]
      }
    ]
  },
  'HANOI': {
    standName: 'Hanoi Night Market',
    standIcon: 'Utensils',
    cuisine: 'Vietnamese',
    quests: [
      {
        id: 'hanoi_pho_stall',
        name: 'Midnight Pho Quest',
        description: 'The aromatic beef broth of Hanoi is calling. Perfect for late night hunger!',
        location: 'Old Quarter',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'pho_main',
            name: 'Pho Bo (Beef Noodle Soup)',
            emoji: '🍜',
            calories: 350,
            protein: 25,
            carbs: 50,
            fat: 8,
            description: 'Rice noodle soup with rare beef, brisket, and fresh herbs in a clear bone broth.',
            ingredients: ['Rice noodles', 'Beef broth', 'Beef slices', 'Bean sprouts', 'Thai basil', 'Hoisin sauce', 'Sriracha'],
            allergens: ['Fish', 'Soy'],
            cookingMethod: 'Simmered broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/25/Vietnamsk%C3%A9_%C5%A1irok%C3%A9_r%C3%BD%C5%BEov%C3%A9_nudle_b%C3%A1nh_ph%E1%BB%9F_01.JPG'
          }
        ]
      }
    ]
  },
  'CAIRO': {
    standName: 'Cairo Street Cart',
    standIcon: 'Cookie',
    cuisine: 'Egyptian',
    quests: [
      {
        id: 'cairo_koshary',
        name: 'Koshary King',
        description: 'Master the mix of pasta, rice, and lentils. The ultimate Egyptian fuel!',
        location: 'Tahrir Square',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'koshary_1',
            name: 'Traditional Koshary',
            emoji: '🍲',
            calories: 450,
            protein: 15,
            carbs: 85,
            fat: 5,
            description: 'Mix of rice, lentils, pasta with spicy tomato sauce and fried onions',
            ingredients: ['Rice', 'Lentils', 'Macaroni', 'Tomato sauce', 'Fried onions', 'Chickpeas'],
            allergens: ['Wheat'],
            cookingMethod: 'Boiled and topped with sauce',
            image: 'https://upload.wikimedia.org/wikipedia/commons/f/f2/Koshary_in_Khan_el_Khalili.jpg'
          }
        ]
      }
    ]
  },
  'LONDON': {
    standName: 'London Chipping',
    standIcon: 'Star',
    cuisine: 'British',
    quests: [
      {
        id: 'london_fish_chips',
        name: 'Traditional Fish & Chips',
        description: 'Crispy battered fish with chunky chips. A London staple!',
        location: 'Camden Market',
        reward: 50000,
        fanReward: 15000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'fish_chips_1',
            name: 'Cod & Chips',
            emoji: '🐟',
            calories: 600,
            protein: 25,
            carbs: 60,
            fat: 30,
            description: 'Beer-battered cod with triple-cooked chips',
            ingredients: ['Cod', 'Potatoes', 'Flour', 'Beer', 'Peas', 'Tartar sauce'],
            allergens: ['Fish', 'Wheat'],
            cookingMethod: 'Deep fried in batter',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Traditional_fish_and_chips.jpg'
          }
        ]
      }
    ]
  },
  'NEW_YORK': {
    standName: 'Manhattan Cart',
    standIcon: 'Heart',
    cuisine: 'American',
    quests: [
      {
        id: 'nyc_hotdog',
        name: 'Gray\'s Style Dog',
        description: 'The iconic New York street snack. Fast, spicy, and delicious!',
        location: 'Times Square',
        reward: 30000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'hotdog_1',
            name: 'Classic NYC Hot Dog',
            emoji: '🌭',
            calories: 300,
            protein: 12,
            carbs: 25,
            fat: 18,
            description: 'Beef frankfurter with mustard and kraut',
            ingredients: ['Beef frankfurter', 'Buns', 'Mustard', 'Sauerkraut', 'Onions'],
            allergens: ['Wheat'],
            cookingMethod: 'Grilled or boiled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/99/NYC_Hotdog_cart_-_hot_dogs_closeup.jpg'
          }
        ]
      }
    ]
  },
  'HO_CHI_MINH_CITY': {
    standName: 'Saigon Banh Mi Cart',
    standIcon: 'Utensils',
    cuisine: 'Vietnamese',
    quests: [
      {
        id: 'saigon_banh_mi',
        name: 'Banh Mi Bonanza',
        description: 'Try the famous crusty baguettes filled with pate, meats, and fresh herbs.',
        location: 'Ben Thanh Market',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'banh_mi_1',
            name: 'Saigon Special Banh Mi',
            emoji: '🥖',
            calories: 420,
            protein: 15,
            carbs: 55,
            fat: 18,
            description: 'Vietnamese baguette with pate, pork, and pickled veggies',
            ingredients: ['Baguette', 'Pate', 'Pork belly', 'Cucumber', 'Cilantro', 'Pickled carrots', 'Daikon'],
            allergens: ['Wheat', 'Soy'],
            cookingMethod: 'Assembled in crusty baguette',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Banh_mi_sandwich.jpg'
          }
        ]
      }
    ]
  },
  'TRIPOLI': {
    standName: 'Tripoli Tabuna Bakery',
    standIcon: 'Cookie',
    cuisine: 'Libyan',
    quests: [
      {
        id: 'tripoli_tabuna',
        name: 'Tabuna Bread Trial',
        description: 'Crispy traditional bread baked in a clay oven. The heart of Tripoli!',
        location: 'Old City',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tabuna_1',
            name: 'Traditional Tabuna Bread',
            emoji: '🍞',
            calories: 280,
            protein: 8,
            carbs: 58,
            fat: 4,
            description: 'Fresh clay-oven bread served with olive oil and harissa',
            ingredients: ['Flour', 'Water', 'Yeast', 'Salt', 'Olive oil'],
            allergens: ['Wheat'],
            cookingMethod: 'Baked in clay tabuna oven',
            image: 'https://upload.wikimedia.org/wikipedia/commons/e/e9/Tabouna_bread_Kairouan.jpg'
          }
        ]
      }
    ]
  },
  'TUNIS': {
    standName: 'Tunis Brik Stall',
    standIcon: 'Heart',
    cuisine: 'Tunisian',
    quests: [
      {
        id: 'tunis_brik',
        name: 'Crispy Brik Challenge',
        description: 'Master the art of eating the crispy thin pastry with a runny egg center!',
        location: 'La Goulette',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'brik_1',
            name: 'Classic Egg Brik',
            emoji: '🥟',
            calories: 250,
            protein: 12,
            carbs: 18,
            fat: 14,
            description: 'Thin pastry with egg, tuna, and capers',
            ingredients: ['Malsouka pastry', 'Egg', 'Tuna', 'Capers', 'Parsley'],
            allergens: ['Wheat', 'Eggs', 'Fish'],
            cookingMethod: 'Deep fried until golden',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/07/Brik_tunisien%2C_mai_2020.jpg'
          }
        ]
      }
    ]
  },
  'ALGIERS': {
    standName: 'Algiers Mahdjouba Stand',
    standIcon: 'ChefHat',
    cuisine: 'Algerian',
    quests: [
      {
        id: 'algiers_mahdjouba',
        name: 'Spicy Mahdjouba Quest',
        description: 'Try the thin semolina crepes filled with spicy onion and tomato.',
        location: 'Casbah of Algiers',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mahdjouba_1',
            name: 'Algerian Mahdjouba',
            emoji: '🫓',
            calories: 310,
            protein: 6,
            carbs: 48,
            fat: 10,
            description: 'Spicy semolina crepe with onion and tomato filling',
            ingredients: ['Semolina', 'Onion', 'Tomato', 'Spices', 'Olive oil'],
            allergens: ['Wheat'],
            cookingMethod: 'Griddle cooked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/e/ed/Kesra_alg%C3%A9rienne_%28pain_maghr%C3%A9bin%29.jpg'
          }
        ]
      }
    ]
  },
  'CASABLANCA': {
    standName: 'Casa Sardine Grill',
    standIcon: 'ChefHat',
    cuisine: 'Moroccan',
    quests: [
      {
        id: 'casa_sardines',
        name: 'Grilled Sardine Feast',
        description: 'Fresh sardines grilled with herbs and spices right by the port.',
        location: 'Casablanca Port',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sardine_main',
            name: 'Grilled Moroccan Sardines',
            emoji: '🐟',
            calories: 240,
            protein: 22,
            carbs: 2,
            fat: 16,
            description: 'Freshly grilled sardines marinated in chermoula and served with onions.',
            ingredients: ['Sardines', 'Chermoula spice', 'Parsley', 'Cilantro', 'Garlic', 'Onions'],
            allergens: ['Fish'],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/83/Sardines_frit_avec_la_chermoulla.jpg'
          }
        ]
      }
    ]
  },
  'MARRAKECH': {
    standName: 'Marrakech Harira Bowl',
    standIcon: 'Utensils',
    cuisine: 'Moroccan',
    quests: [
      {
        id: 'marrakech_harira',
        name: 'Traditional Harira Pot',
        description: 'Taste the legendary Moroccan soup made with lentils, chickpeas, and tomato.',
        location: 'Jemaa el-Fnaa',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'harira_main',
            name: 'Harira Soup',
            emoji: '🥣',
            calories: 220,
            protein: 10,
            carbs: 35,
            fat: 6,
            description: 'Zesty Moroccan soup with lentils, chickpeas, and vermicelli.',
            ingredients: ['Lentils', 'Chickpeas', 'Tomato', 'Coriander', 'Lemon', 'Spices'],
            allergens: ['Celery', 'Gluten'],
            cookingMethod: 'Slow simmered',
            image: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Guests_adjust_the_spice_before_enjoying_ph%E1%BB%9F_15-07-2018.jpg'
          }
        ]
      }
    ]
  },
  'DAKAR': {
    standName: 'Dakar Dibi Shack',
    standIcon: 'ChefHat',
    cuisine: 'Senegalese',
    quests: [
      {
        id: 'dakar_dibi',
        name: 'Grilled Dibi Treat',
        description: 'Seasoned lamb grilled over wood fire and served in brown paper bags.',
        location: 'Sandaga Market',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'dibi_main',
            name: 'Senegalese Dibi',
            emoji: '🥩',
            calories: 480,
            protein: 35,
            carbs: 4,
            fat: 36,
            description: 'Wood-fired lamb chops with mustard and onions.',
            ingredients: ['Lamb chops', 'Onions', 'Mustard', 'Black pepper'],
            allergens: ['Mustard'],
            cookingMethod: 'Wood-fired grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/7/7d/CeebuYapp.jpg'
          }
        ]
      }
    ]
  },
  'ABIDJAN': {
    standName: 'Abidjan Garba Corner',
    standIcon: 'Star',
    cuisine: 'Ivorian',
    quests: [
      {
        id: 'abidjan_garba',
        name: 'Authentic Garba Mix',
        description: 'The beloved street food of Abidjan: Attiéké with fried tuna.',
        location: 'Adjame',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'garba_main',
            name: 'Garba (Attiéké & Tuna)',
            emoji: '🐟',
            calories: 410,
            protein: 28,
            carbs: 52,
            fat: 10,
            description: 'Fermented cassava couscous (Attiéké) served with fried tuna and chilies.',
            ingredients: ['Attiéké (cassava)', 'Tuna', 'Onion', 'Chili', 'Cube seasoning'],
            allergens: ['Fish'],
            cookingMethod: 'Fried tuna with steamed cassava',
            image: 'https://upload.wikimedia.org/wikipedia/commons/c/cc/Garba_plat_ivoirien.JPG'
          }
        ]
      }
    ]
  },
  'ACCRA': {
    standName: 'Accra Kelewele Spot',
    standIcon: 'Heart',
    cuisine: 'Ghanaian',
    quests: [
      {
        id: 'accra_kelewele',
        name: 'Spicy Kelewele Snack',
        description: 'Spiced and fried plantain cubes. The perfect nightlife snack in Accra!',
        location: 'Oxford Street',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kelewele_main',
            name: 'Kelewele',
            emoji: '🍌',
            calories: 250,
            protein: 2,
            carbs: 45,
            fat: 8,
            description: 'Fried ripe plantain seasoned with ginger, pepper, and spices.',
            ingredients: ['Ripe plantain', 'Ginger', 'Pepper', 'Cloves', 'Nutmeg', 'Salt'],
            allergens: [],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Kelewele.jpg'
          }
        ]
      }
    ]
  },
  'LOME': {
    standName: 'Lome Ayimolou Cart',
    standIcon: 'Utensils',
    cuisine: 'Togolese',
    quests: [
      {
        id: 'lome_ayimolou',
        name: 'Ayimolou Breakfast Run',
        description: 'Traditional Togolese rice and beans served with spicy gari.',
        location: 'Grand Marche',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'ayimolou_main',
            name: 'Ayimolou (Rice & Beans)',
            emoji: '🍱',
            calories: 380,
            protein: 12,
            carbs: 68,
            fat: 6,
            description: 'Rice and black-eyed peas cooked together, served with spicy sauce and gari.',
            ingredients: ['Rice', 'Black eyed peas', 'Spicy sauce', 'Gari', 'Egg'],
            allergens: ['Eggs'],
            cookingMethod: 'Steamed rice and beans',
            image: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Ayimolou_%28Riz_au_haricot%29_01.jpg'
          }
        ]
      }
    ]
  },
  'KHARTOUM': {
    standName: 'Khartoum Ful Cart',
    standIcon: 'Utensils',
    cuisine: 'Sudanese',
    quests: [
      {
        id: 'khartoum_ful',
        name: 'Master Ful Medames',
        description: 'The staple Sudanese breakfast of mashed fava beans with oil and spices.',
        location: 'Souq Arabi',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'ful_main',
            name: 'Sudanese Ful Medames',
            emoji: '🥘',
            calories: 340,
            protein: 18,
            carbs: 52,
            fat: 8,
            description: 'Fava beans with sesame oil, cheese, and spicy arugula',
            ingredients: ['Fava beans', 'Sesame oil', 'Feta cheese', 'Arugula', 'Garlic', 'Cumin'],
            allergens: ['Dairy'],
            cookingMethod: 'Slow simmered beans',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/04/Sudanese_traditional_beans_soup.jpg'
          }
        ]
      }
    ]
  },
  'ADDIS_ABABA': {
    standName: 'Addis Sambusa Stall',
    standIcon: 'Cookie',
    cuisine: 'Ethiopian',
    quests: [
      {
        id: 'addis_sambusa',
        name: ' Sambusa Sprint',
        description: 'Crispy fried pastries filled with lentils or meat. A favorite on-the-go snack!',
        location: 'Merkato',
        reward: 33000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sambusa_main',
            name: 'Ethiopian Lentil Sambusa',
            emoji: '🥟',
            calories: 180,
            protein: 6,
            carbs: 22,
            fat: 8,
            description: 'Spicy lentil-filled fried pastry',
            ingredients: ['Pastry', 'Lentils', 'Onions', 'Green chili', 'Berbere spice'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Ethiopian_Sambusa.jpg'
          }
        ]
      }
    ]
  },
  'NAIROBI': {
    standName: 'Nairobi Mahindi Grill',
    standIcon: 'ChefHat',
    cuisine: 'Kenyan',
    quests: [
      {
        id: 'nairobi_mahindi',
        name: 'Roasted Mahindi Quest',
        description: 'Charcoal-grilled corn cob rubbed with lemon and chili. The scent of Nairobi streets!',
        location: 'City Market',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mahindi_main',
            name: 'Mahindi Choma',
            emoji: '🌽',
            calories: 150,
            protein: 4,
            carbs: 32,
            fat: 2,
            description: 'Roasted corn with chili-lemon rub',
            ingredients: ['Corn', 'Lemon', 'Salt', 'Chili powder'],
            allergens: [],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/5/58/Grilled_Corn_on_the_cob.JPG'
          }
        ]
      }
    ]
  },
  'MOGADISHU': {
    standName: 'Mogadishu Sambuusa Shop',
    standIcon: 'Utensils',
    cuisine: 'Somali',
    quests: [
      {
        id: 'moga_sambuusa',
        name: 'Sambuusa Street Tour',
        description: 'Delicious fried pastries filled with spiced meat and onions.',
        location: 'Bakara Market',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sambuusa_main',
            name: 'Somali Meat Sambuusa',
            emoji: '🥟',
            calories: 220,
            protein: 12,
            carbs: 18,
            fat: 12,
            description: 'Pastry filled with spicy ground beef and scallions',
            ingredients: ['Thin pastry', 'Ground beef', 'Onions', 'Cumin', 'Cardamom', 'Green chili'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried until crispy',
            image: 'https://upload.wikimedia.org/wikipedia/commons/f/fc/Sambussa.jpg'
          }
        ]
      }
    ]
  },
  'DAR_ES_SALAAM': {
    standName: 'Dar Chips Mayai Point',
    standIcon: 'Star',
    cuisine: 'Tanzanian',
    quests: [
      {
        id: 'dar_chips_mayai',
        name: 'Chips Mayai Master',
        description: 'Tanzania\'s famous french fry omelette. Simple, filling, and iconic!',
        location: 'Kivukoni',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chips_mayai_main',
            name: 'Classic Chips Mayai',
            emoji: '🍳',
            calories: 450,
            protein: 14,
            carbs: 48,
            fat: 22,
            description: 'French fried potatoes fried into an omelette',
            ingredients: ['Potatoes', 'Eggs', 'Salt', 'Oil', 'Kachumbari (salad)'],
            allergens: ['Eggs'],
            cookingMethod: 'Pan fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Chips_with_pickled_vegetables.jpg'
          }
        ]
      }
    ]
  },
  'KAMPALA': {
    standName: 'Kampala Rolex Stall',
    standIcon: 'ChefHat',
    cuisine: 'Ugandan',
    quests: [
      {
        id: 'kampala_rolex',
        name: 'The Rolex Roll',
        description: 'Not the watch! It\'s "Rolled Eggs"—an omelette rolled in a chapati.',
        location: 'Wandegeya',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'rolex_main',
            name: 'Ugandan Rolex',
            emoji: '🌯',
            calories: 420,
            protein: 16,
            carbs: 44,
            fat: 18,
            description: 'Veggie omelette rolled inside a fresh chapati',
            ingredients: ['Wheat chapati', 'Eggs', 'Cabbage', 'Tomato', 'Onions'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Grilled chapati and fried omelette',
            image: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/A_bitten_off_Ugandan_rolex.jpg'
          }
        ]
      }
    ]
  },
  'KIGALI': {
    standName: 'Kigali Brochette Grill',
    standIcon: 'Star',
    cuisine: 'Rwandan',
    quests: [
      {
        id: 'kigali_brochette',
        name: 'Brochette Grill Night',
        description: 'Skewered goat meat or fish grilled to perfection with spicy pili-pili.',
        location: 'Nyamirambo',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'brochette_main',
            name: 'Rwandan Goat Brochette',
            emoji: '🍢',
            calories: 320,
            protein: 34,
            carbs: 2,
            fat: 18,
            description: 'Grilled goat meat skewers with onion and pepper',
            ingredients: ['Goat meat', 'Leeks', 'Oil', 'Pili-pili sauce'],
            allergens: [],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/68/Brochetas_de_Chorizo_y_Butifarra.jpg'
          }
        ]
      }
    ]
  },
  'BUJUMBURA': {
    standName: 'Bujumbura Fish Hub',
    standIcon: 'Utensils',
    cuisine: 'Burundian',
    quests: [
      {
        id: 'buju_fish',
        name: 'Lake Tanganyika Feast',
        description: 'Freshly fried Mukeke fish from the lake. Best enjoyed on the shore!',
        location: 'Saga Beach',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mukeke_main',
            name: 'Fried Mukeke Fish',
            emoji: '🐟',
            calories: 280,
            protein: 26,
            carbs: 4,
            fat: 18,
            description: 'Crispy fried whole Mukeke fish',
            ingredients: ['Mukeke fish', 'Flour', 'Lemon', 'Spices'],
            allergens: ['Fish', 'Wheat'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/62/Fish_and_sugarcanes.jpg'
          }
        ]
      }
    ]
  },
  'KINSHASA': {
    standName: 'Kinshasa Kwanga Corner',
    standIcon: 'ChefHat',
    cuisine: 'Congolese',
    quests: [
      {
        id: 'kin_kwanga',
        name: 'Kwanga & Fish Run',
        description: 'Traditional fermented cassava bread served with grilled fish.',
        location: 'Gombe',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kwanga_main',
            name: 'Congolese Kwanga',
            emoji: '🥖',
            calories: 350,
            protein: 4,
            carbs: 82,
            fat: 1,
            description: 'Fermented cassava bread wrapped in banana leaves',
            ingredients: ['Cassava', 'Water'],
            allergens: [],
            cookingMethod: 'Steamed in banana leaves',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Kwanga.jpg'
          }
        ]
      }
    ]
  },
  'LUANDA': {
    standName: 'Luanda Mufete Grill',
    standIcon: 'Utensils',
    cuisine: 'Angolan',
    quests: [
      {
        id: 'luanda_mufete',
        name: 'Mufete Mastery',
        description: 'Angola\'s favorite grilled fish meal with beans and sweet potato.',
        location: 'Ilha de Luanda',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mufete_main',
            name: 'Angolan Mufete',
            emoji: '🐟',
            calories: 520,
            protein: 38,
            carbs: 45,
            fat: 22,
            description: 'Grilled tilapia with palm oil beans and sweet potato',
            ingredients: ['Tilapia', 'Sweet potato', 'Plantain', 'Palm oil beans', 'Onion salsa'],
            allergens: ['Fish'],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Mufete.jpg'
          }
        ]
      }
    ]
  },
  'WINDHOEK': {
    standName: 'Windhoek Kapana Grill',
    standIcon: 'ChefHat',
    cuisine: 'Namibian',
    quests: [
      {
        id: 'windhoek_kapana',
        name: 'Kapana Meat Market',
        description: 'Grilled beef strips prepared in an open-air market. The true taste of Windhoek!',
        location: 'Single Quarters',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kapana_main',
            name: 'Namibian Kapana',
            emoji: '🥩',
            calories: 320,
            protein: 28,
            carbs: 2,
            fat: 22,
            description: 'Grilled beef with chili salt and fat',
            ingredients: ['Beef', 'Chili salt', 'Salsa'],
            allergens: [],
            cookingMethod: 'Open-fire grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Kapana_meat.jpg'
          }
        ]
      }
    ]
  },
  'GABORONE': {
    standName: 'Gaborone Seswaa Pot',
    standIcon: 'Utensils',
    cuisine: 'Botswana',
    quests: [
      {
        id: 'gabo_seswaa',
        name: 'Seswaa Pounding',
        description: 'Traditional slow-cooked and pounded meat dish. Savory and hearty.',
        location: 'Main Mall',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'seswaa_main',
            name: 'Traditional Seswaa',
            emoji: '🍲',
            calories: 410,
            protein: 36,
            carbs: 4,
            fat: 28,
            description: 'Pounded slow-cooked beef with salt',
            ingredients: ['Beef', 'Water', 'Salt'],
            allergens: [],
            cookingMethod: 'Slow cooked and pounded',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8b/Seswaa.jpg'
          }
        ]
      }
    ]
  },
  'HARARE': {
    standName: 'Harare Sadza Spot',
    standIcon: 'Star',
    cuisine: 'Zimbabwean',
    quests: [
      {
        id: 'harare_sadza',
        name: 'The Sadza Challenge',
        description: 'The national dish of Zimbabwe. Cornmeal porridge with savory greens and meat.',
        location: 'Mbare Musika',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sadza_main',
            name: 'Sadza and Nyama',
            emoji: '🥣',
            calories: 380,
            protein: 18,
            carbs: 65,
            fat: 4,
            description: 'White cornmeal porridge served with beef stew',
            ingredients: ['Cornmeal', 'Beef stew', 'Leafy greens'],
            allergens: [],
            cookingMethod: 'Cooked cornmeal porridge',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Sadza_with_stew.jpg'
          }
        ]
      }
    ]
  },
  'LUSAKA': {
    standName: 'Lusaka Tilapia Market',
    standIcon: 'Utensils',
    cuisine: 'Zambian',
    quests: [
      {
        id: 'lusaka_fish',
        name: 'Lusaka Fish Fry',
        description: 'Fresh Nile Tilapia from the Kafue River, served fried with Nshima.',
        location: 'Soweto Market',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tilapia_main',
            name: 'Grilled Zambian Tilapia',
            emoji: '🐟',
            calories: 290,
            protein: 24,
            carbs: 2,
            fat: 22,
            description: 'Crispy fried tilapia fish',
            ingredients: ['Tilapia', 'Lemon', 'Spices'],
            allergens: ['Fish'],
            cookingMethod: 'Fried or grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8e/Fried_tilapia_fish.jpg'
          }
        ]
      }
    ]
  },
  'LILONGWE': {
    standName: 'Lilongwe Chambo Grill',
    standIcon: 'ChefHat',
    cuisine: 'Malawian',
    quests: [
      {
        id: 'lilo_chambo',
        name: 'Lake Malawi Chambo',
        description: 'Taste the famous Chambo fish, unique to Lake Malawi.',
        location: 'Lilongwe Old Town Market',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chambo_main',
            name: 'Grilled Chambo',
            emoji: '🐟',
            calories: 260,
            protein: 28,
            carbs: 0,
            fat: 16,
            description: 'Grilled Chambo fish with spices',
            ingredients: ['Chambo fish', 'Lemon', 'Tomato', 'Onion'],
            allergens: ['Fish'],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3a/Chambo_fish.jpg'
          }
        ]
      }
    ]
  },
  'BLANTYRE': {
    standName: 'Blantyre Mandasi Shop',
    standIcon: 'Cookie',
    cuisine: 'Malawian',
    quests: [
      {
        id: 'blan_mandasi',
        name: 'Mandasi Morning',
        description: 'Warm, sweet fried dough balls. A perfect breakfast on the go!',
        location: 'Blantyre Central Market',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mandasi_main',
            name: 'Malawian Mandasi',
            emoji: '🥯',
            calories: 180,
            protein: 4,
            carbs: 32,
            fat: 6,
            description: 'Fried dough balls without sugar coating',
            ingredients: ['Flour', 'Sugar', 'Yeast', 'Cardamom'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Churros_%2828931960476%29.jpg'
          }
        ]
      }
    ]
  },
  'MAPUTO': {
    standName: 'Maputo Prawn Grill',
    standIcon: 'Utensils',
    cuisine: 'Mozambican',
    quests: [
      {
        id: 'maputo_prawns',
        name: 'Peri-Peri Prawn Feast',
        description: 'Famous Mozambican prawns grilled with spicy peri-peri sauce.',
        location: 'Mercado de Peixe',
        reward: 48000,
        fanReward: 14000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'prawn_main',
            name: 'Maputo Peri-Peri Prawns',
            emoji: '🦐',
            calories: 210,
            protein: 24,
            carbs: 4,
            fat: 12,
            description: 'Grilled jumbo prawns in spicy peri-peri marinade',
            ingredients: ['Prawns', 'Peri-peri sauce', 'Garlic', 'Lemon'],
            allergens: ['Shellfish'],
            cookingMethod: 'Grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Piri-piri_prawns.jpg'
          }
        ]
      }
    ]
  },
  'BRAZZAVILLE': {
    standName: 'Brazza Saka-Saka Hub',
    standIcon: 'ChefHat',
    cuisine: 'Congolese',
    quests: [
      {
        id: 'brazza_saka',
        name: 'The Saka-Saka Stew',
        description: 'Traditional cassava leaf stew. Highly nutritious and delicious!',
        location: 'Marché Total',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'saka_main',
            name: 'Congolese Saka-Saka',
            emoji: '🥗',
            calories: 320,
            protein: 8,
            carbs: 45,
            fat: 14,
            description: 'Cassava leaf stew with palm oil and fish',
            ingredients: ['Cassava leaves', 'Palm oil', 'Fish', 'Spices'],
            allergens: ['Fish'],
            cookingMethod: 'Slow simmered',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Saka_saka.jpg'
          }
        ]
      }
    ]
  },
  'LAGOS': {
    standName: 'Lagos Suya Spot',
    standIcon: 'Star',
    cuisine: 'Nigerian',
    quests: [
      {
        id: 'lagos_suya',
        name: 'Suya Night Run',
        description: 'Spicy skewered meat with peanut spice. Lagos nights are not complete without it!',
        location: 'Ikeja',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'suya_main',
            name: 'Beef Suya',
            emoji: '🍢',
            calories: 380,
            protein: 32,
            carbs: 4,
            fat: 26,
            description: 'Spicy skewered beef marinated in Yaji (peanut spice) and grilled.',
            ingredients: ['Beef', 'Kuli-kuli (peanut cake) spice', 'Ginger', 'Stock cube', 'Onions'],
            allergens: ['Peanuts'],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Suya_meat.jpg'
          }
        ]
      }
    ]
  },
  'JOHANNESBURG': {
    standName: 'Joburg Kota Point',
    standIcon: 'ChefHat',
    cuisine: 'South African',
    quests: [
      {
        id: 'joburg_kota',
        name: 'The Kota King',
        description: 'Try the iconic quarter-loaf "Kota" sandwich filled with all the fixings.',
        location: 'Soweto',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kota_main',
            name: 'Joburg Kota',
            emoji: '🍞',
            calories: 550,
            protein: 18,
            carbs: 65,
            fat: 25,
            description: 'Quarter loaf hollowed and filled with chips, polony, and egg',
            ingredients: ['White bread', 'Potato chips', 'Polony', 'Fried egg', 'Atchar'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Assembled inside hollowed bread',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Kota_sandwich.jpg'
          }
        ]
      }
    ]
  },
  'CAPE_TOWN': {
    standName: 'Mother City Gatsby',
    standIcon: 'Utensils',
    cuisine: 'South African',
    quests: [
      {
        id: 'cape_gatsby',
        name: 'The Great Gatsby',
        description: 'Be warned: The Gatsby is huge. A legendary sandwich meant for sharing!',
        location: 'Athlone',
        reward: 45000,
        fanReward: 13500,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'gatsby_1',
            name: 'Cape Town Steak Gatsby',
            emoji: '🥖',
            calories: 850,
            protein: 45,
            carbs: 95,
            fat: 35,
            description: 'Foot-long roll with steak, chips, and masala sauce',
            ingredients: ['Long roll', 'Masala steak', 'Slap chips', 'Masala sauce', 'Salad'],
            allergens: ['Wheat'],
            cookingMethod: 'Assembled in long roll',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Gatsby_sandwich.jpg'
          }
        ]
      }
    ]
  },
  'LUXEMBOURG': {
    standName: 'Luxembourg Potato Hut',
    standIcon: 'ChefHat',
    cuisine: 'Luxembourgish',
    quests: [
      {
        id: 'lux_potato_pancake',
        name: 'Gromperekichelcher Gala',
        description: 'Crispy fried potato pancakes with onions and parsley. A local festival favorite!',
        location: 'Place d\'Armes',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'potato_pancake_main',
            name: 'Gromperekichelcher',
            emoji: '🥞',
            calories: 280,
            protein: 4,
            carbs: 45,
            fat: 12,
            description: 'Shredded potato pancakes with onions and parsley',
            ingredients: ['Potatoes', 'Onions', 'Eggs', 'Parsley', 'Flour'],
            allergens: ['Eggs', 'Wheat'],
            cookingMethod: 'Deep fried until golden',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Gromperekichelcher.jpg'
          }
        ]
      }
    ]
  },
  'BRUSSELS': {
    standName: 'Brussels Waffle Window',
    standIcon: 'Cookie',
    cuisine: 'Belgian',
    quests: [
      {
        id: 'brussels_waffle',
        name: 'Liege Waffle Walk',
        description: 'Warm, caramelized waffles with pearl sugar. The true scent of Brussels!',
        location: 'Grand Place',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'waffle_main',
            name: 'Liege Waffle',
            emoji: '🧇',
            calories: 380,
            protein: 5,
            carbs: 48,
            fat: 18,
            description: 'Yeast-leavened waffle with caramelized pearl sugar',
            ingredients: ['Flour', 'Butter', 'Pearl sugar', 'Yeast', 'Eggs'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Iron pressed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Liege_waffle_with_pearl_sugar.jpg'
          }
        ]
      }
    ]
  },
  'AMSTERDAM': {
    standName: 'Amsterdam Stroop Shop',
    standIcon: 'Cookie',
    cuisine: 'Dutch',
    quests: [
      {
        id: 'dam_stroopwafel',
        name: 'Fresh Stroopwafel Spin',
        description: 'Two thin waffles joined by hot caramel syrup. Watch it being made!',
        location: 'Albert Cuyp Market',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'stroopwafel_main',
            name: 'Fresh Hot Stroopwafel',
            emoji: '🧇',
            calories: 180,
            protein: 2,
            carbs: 28,
            fat: 8,
            description: 'Thin waffle with caramel syrup filling',
            ingredients: ['Flour', 'Butter', 'Brown sugar', 'Cinnamon', 'Syrup'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Pressed and sliced',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Stroopwafel.jpg'
          }
        ]
      }
    ]
  },
  'FRANKFURT': {
    standName: 'Frankfurt Wurst Stand',
    standIcon: 'ChefHat',
    cuisine: 'German',
    quests: [
      {
        id: 'frank_currywurst',
        name: 'Currywurst Combo',
        description: 'Iconic sliced sausage with curry ketchup and fries. The ultimate German street snack!',
        location: 'Zeil',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'currywurst_main',
            name: 'Stadion Currywurst',
            emoji: '🌭',
            calories: 450,
            protein: 18,
            carbs: 35,
            fat: 28,
            description: 'Steamed, then fried pork sausage with curry ketchup',
            ingredients: ['Pork sausage', 'Curry ketchup', 'Curry powder', 'Fries'],
            allergens: [],
            cookingMethod: 'Grilled and sliced',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Currywurst-2024.jpg'
          }
        ]
      }
    ]
  },
  'ZURICH': {
    standName: 'Zurich Cheese Chalet',
    standIcon: 'Utensils',
    cuisine: 'Swiss',
    quests: [
      {
        id: 'zurich_raclette',
        name: 'Raclette to Go',
        description: 'Melted Swiss cheese scraped onto fresh bread. Warm and gooey!',
        location: 'Bahnhofstrasse',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'raclette_main',
            name: 'Swiss Raclette Bread',
            emoji: '🧀',
            calories: 320,
            protein: 16,
            carbs: 32,
            fat: 18,
            description: 'Melted raclette cheese on baguette with pickles',
            ingredients: ['Raclette cheese', 'Baguette', 'Pickled onions', 'Cornichons'],
            allergens: ['Dairy', 'Wheat'],
            cookingMethod: 'Cheese melted and scraped',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Raclette_cheese_melting.jpg'
          }
        ]
      }
    ]
  },
  'MILAN': {
    standName: 'Milan Panzerotti Window',
    standIcon: 'Heart',
    cuisine: 'Italian',
    quests: [
      {
        id: 'milan_panzerotti',
        name: 'Luini Style Panzerotti',
        description: 'Fried dough pockets filled with tomato and mozzarella. A Milanese institution!',
        location: 'Via Santa Radegonda',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'panzerotti_main',
            name: 'Tomato Mozzarella Panzerotti',
            emoji: '🥐',
            calories: 290,
            protein: 10,
            carbs: 38,
            fat: 12,
            description: 'Fried dough filled with tomato sauce and mozzarella',
            ingredients: ['Dough', 'Tomato sauce', 'Mozzarella', 'Oregano'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Panzerotti.jpg'
          }
        ]
      }
    ]
  },
  'OSLO': {
    standName: 'Oslo Pølse Cart',
    standIcon: 'Star',
    cuisine: 'Norwegian',
    quests: [
      {
        id: 'oslo_polse',
        name: 'Pølse i Lompe Parade',
        description: 'Norwegian hot dog wrapped in a soft potato tortilla. The standard Oslo snack!',
        location: 'Karl Johans gate',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'polse_main',
            name: 'Hot Dog in Lompe',
            emoji: '🌭',
            calories: 240,
            protein: 10,
            carbs: 32,
            fat: 14,
            description: 'Sausage in a potato wrap with fried onions',
            ingredients: ['Sausage', 'Lompe (potato wrap)', 'Fried onions', 'Ketchup', 'Mustard'],
            allergens: ['Wheat'],
            cookingMethod: 'Boiled or grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/P%C3%B8lse_i_lompe.jpg'
          }
        ]
      }
    ]
  },
  'COPENHAGEN': {
    standName: 'Copenhagen Hotdog Hub',
    standIcon: 'ChefHat',
    cuisine: 'Danish',
    quests: [
      {
        id: 'cph_hotdog',
        name: 'Ristet Pølse Run',
        description: 'Classic Danish roasted hot dog with all the toppings: remoulade, pickles, and crisp onions.',
        location: 'Strøget',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'cph_hotdog_main',
            name: 'Danish Roasted Hotdog',
            emoji: '🌭',
            calories: 310,
            protein: 12,
            carbs: 35,
            fat: 18,
            description: 'Roasted red sausage in bun with Danish remoulade',
            ingredients: ['Red sausage', 'Hotdog bun', 'Remoulade', 'Pickles', 'Crispy onions'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Ristet_p%C3%B8lse_med_tilbeh%C3%B8r.jpg'
          }
        ]
      }
    ]
  },
  'HELSINKI': {
    standName: 'Helsinki Meat Pie Stall',
    standIcon: 'Cookie',
    cuisine: 'Finnish',
    quests: [
      {
        id: 'hel_meatpie',
        name: 'Lihapiirakka Lunch',
        description: 'Savory meat pies fried in dough. Try it with two frankfurters inside!',
        location: 'Kauppatori',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'meatpie_main',
            name: 'Finnish Lihapiirakka',
            emoji: '🥟',
            calories: 380,
            protein: 14,
            carbs: 42,
            fat: 20,
            description: 'Fried dough filled with ground meat and rice',
            ingredients: ['Dough', 'Ground beef', 'Rice', 'Onions', 'Spices'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Lihapiirakka.jpg'
          }
        ]
      }
    ]
  },
  'TALLINN': {
    standName: 'Tallinn Old Town Snack',
    standIcon: 'Utensils',
    cuisine: 'Estonian',
    quests: [
      {
        id: 'tal_sprat',
        name: 'Kiluvõileib Kit',
        description: 'Traditional Estonian spiced sprat sandwiches. A bite of the Baltic!',
        location: 'Raekoja plats',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sprat_sandwich_main',
            name: 'Tallinn Sprat Sandwich',
            emoji: '🥪',
            calories: 180,
            protein: 8,
            carbs: 22,
            fat: 8,
            description: 'Black bread with spiced sprat and boiled egg',
            ingredients: ['Rye bread', 'Spiced sprats', 'Boiled egg', 'Green onions'],
            allergens: ['Fish', 'Wheat', 'Eggs'],
            cookingMethod: 'Assembled on rye bread',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Banh_mi_sandwich.jpg'
          }
        ]
      }
    ]
  },
  'RIGA': {
    standName: 'Riga Bacon Bun Corner',
    standIcon: 'Cookie',
    cuisine: 'Latvian',
    quests: [
      {
        id: 'riga_piragi',
        name: 'Speķa Pīrāgi Party',
        description: 'Crescent-shaped buns filled with smoky bacon and onions. Irresistible!',
        location: 'Central Market',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'bacon_bun_main',
            name: 'Speķa Pīrāgi',
            emoji: '🥐',
            calories: 220,
            protein: 6,
            carbs: 28,
            fat: 10,
            description: 'Yeast bun filled with smoked bacon and onions',
            ingredients: ['Yeast dough', 'Smoked bacon', 'Onions', 'Black pepper'],
            allergens: ['Wheat'],
            cookingMethod: 'Oven baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Piragi.jpg'
          }
        ]
      }
    ]
  },
  'VILNIUS': {
    standName: 'Vilnius Kibinai Cart',
    standIcon: 'Utensils',
    cuisine: 'Lithuanian',
    quests: [
      {
        id: 'vil_kibinai',
        name: 'Karaite Kibinai Quest',
        description: 'Flaky pastry pockets filled with spiced meat. A specialty of the Karaite community!',
        location: 'Pilies Street',
        reward: 33000,
        fanReward: 9000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kibinai_main',
            name: 'Lithuanian Kibinas',
            emoji: '🥟',
            calories: 320,
            protein: 12,
            carbs: 35,
            fat: 16,
            description: 'Handmade pastry filled with chopped mutton or pork',
            ingredients: ['Butter pastry', 'Mutton', 'Onions', 'Cumin', 'Black pepper'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Oven baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Kibinai.jpg'
          }
        ]
      }
    ]
  },
  'REYKJAVIK': {
    standName: 'Bæjarins Beztu Pylsur',
    standIcon: 'Star',
    cuisine: 'Icelandic',
    quests: [
      {
        id: 'rey_pylsur',
        name: 'The Famous Lamb Dog',
        description: 'Iceland\'s most popular food! A unique hot dog made with Icelandic lamb.',
        location: 'Reykjavík Harbor',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'icelandic_hotdog_main',
            name: 'Pylsur with Everything',
            emoji: '🌭',
            calories: 280,
            protein: 14,
            carbs: 30,
            fat: 16,
            description: 'Lamb-based hot dog with fried onions and remoulade',
            ingredients: ['Lamb sausage', 'Bun', 'Fried onions', 'Mustard', 'Remoulade'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Steamed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8f/Icelandic_hot_dog.jpg'
          }
        ]
      }
    ]
  },
  'DUBLIN': {
    standName: 'Dublin Spice Bag Shop',
    standIcon: 'Heart',
    cuisine: 'Irish',
    quests: [
      {
        id: 'dublin_spice_bag',
        name: 'Spice Bag Saturday',
        description: 'The modern Dublin street food phenomenon. Salty, spicy, and very addictive!',
        location: 'Temple Bar',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'spice_bag_main',
            name: 'Dublin Spice Bag',
            emoji: '🥡',
            calories: 750,
            protein: 28,
            carbs: 85,
            fat: 38,
            description: 'Crispy chicken, chips, and peppers in a spicy seasoning',
            ingredients: ['Crispy chicken', 'Chips', 'Peppers', 'Onions', 'Salt & Chili spice'],
            allergens: ['Wheat', 'Soy'],
            cookingMethod: 'Deep fried and tossed in spice',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Spice_bag.jpg'
          }
        ]
      }
    ]
  },
  'NICOSIA': {
    standName: 'Ledra Souvlakia',
    standIcon: 'ChefHat',
    cuisine: 'Cypriot',
    quests: [
      {
        id: 'nicosia_souvlaki',
        name: 'Souvlaki in Pitta',
        description: 'Tender grilled pork skewers in a fluffy Cypriot pitta with salad and lemon.',
        location: 'Ledra Street',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'souvlaki_main',
            name: 'Cypriot Souvlaki Pitta',
            emoji: '🍢',
            calories: 420,
            protein: 32,
            carbs: 38,
            fat: 16,
            description: 'Grilled pork skewers inside a large Cypriot pitta',
            ingredients: ['Pork tenderloin', 'Cypriot pitta bread', 'Cucumber', 'Tomato', 'Parsley'],
            allergens: ['Wheat'],
            cookingMethod: 'Charcoal grilled skewers',
            image: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Greek_souvlaki.jpg'
          }
        ]
      }
    ]
  },
  'TEL_AVIV': {
    standName: 'Tel Aviv Falafel Hut',
    standIcon: 'Star',
    cuisine: 'Israeli',
    quests: [
      {
        id: 'tlv_falafel',
        name: 'The Ultimate Pitta',
        description: 'Crispy falafel balls in a fresh pitta with tahini, hummus, and chopped salad.',
        location: 'Carmel Market',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'falafel_main',
            name: 'Falafel in Pitta',
            emoji: '🥙',
            calories: 480,
            protein: 16,
            carbs: 58,
            fat: 22,
            description: 'Fried chickpea balls in pitta bread with salad and tahini',
            ingredients: ['Chickpeas', 'Pitta bread', 'Tahini', 'Hummus', 'Cucumber', 'Tomato'],
            allergens: ['Sesame', 'Wheat'],
            cookingMethod: 'Deep fried balls, assembled in bread',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4b/Gyro_sandwich.jpg'
          }
        ]
      }
    ]
  },
  'BEIRUT': {
    standName: 'Beirut Manakish Bakery',
    standIcon: 'Star',
    cuisine: 'Lebanese',
    quests: [
      {
        id: 'bei_manakish',
        name: 'Morning Za\'atar Run',
        description: 'Freshly baked flatbread topped with za\'atar and olive oil. The breakfast of champions!',
        location: 'Hamra Street',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'manakish_main',
            name: 'Za\'atar Manakish',
            emoji: '🍕',
            calories: 310,
            protein: 8,
            carbs: 42,
            fat: 14,
            description: 'Flatbread topped with sumac, thyme, and sesame blend',
            ingredients: ['Flour dough', 'Za\'atar spice', 'Olive oil'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Oven baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Manakish_zaatar.jpg'
          }
        ]
      }
    ]
  },
  'DAMASCUS': {
    standName: 'Old City Shawarma',
    standIcon: 'ChefHat',
    cuisine: 'Syrian',
    quests: [
      {
        id: 'dam_shawarma',
        name: 'The Damascus Wrap',
        description: 'Thinner bread, extra garlic sauce, and perfectly charred meat.',
        location: 'Straight Street',
        reward: 40000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'shawarma_main',
            name: 'Classic Syrian Shawarma',
            emoji: '🌯',
            calories: 520,
            protein: 34,
            carbs: 45,
            fat: 24,
            description: 'Spiced chicken wrap with garlic paste and pickles',
            ingredients: ['Chicken', 'Thin bread', 'Toum (garlic sauce)', 'Pickles'],
            allergens: ['Wheat'],
            cookingMethod: 'Vertical rotisserie',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d8/Chicken_%26_Lamb_Shawarma.jpg'
          }
        ]
      }
    ]
  },
  'AMMAN': {
    standName: 'Amman Hummus Spot',
    standIcon: 'Star',
    cuisine: 'Jordanian',
    quests: [
      {
        id: 'amm_hummus',
        name: 'The Hummus Bowl',
        description: 'Smooth hummus served warm with olive oil and fresh bread.',
        location: 'Rainbow Street',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'hummus_main',
            name: 'Creamy Amman Hummus',
            emoji: '🥣',
            calories: 340,
            protein: 12,
            carbs: 28,
            fat: 22,
            description: 'Blended chickpeas with tahini and lemon juice',
            ingredients: ['Chickpeas', 'Tahini', 'Lemon juice', 'Olive oil'],
            allergens: ['Sesame'],
            cookingMethod: 'Blended and assembled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/03/Arabic_dish_hummus.jpg'
          }
        ]
      }
    ]
  },
  'TASHKENT': {
    standName: 'Central Asian Plov Center',
    standIcon: 'Star',
    cuisine: 'Uzbek',
    quests: [
      {
        id: 'tash_plov',
        name: 'The Wedding Plov',
        description: 'Magnificent rice dish cooked with meat, carrots, and spices in a giant Kazan.',
        location: 'Old City',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'plov_main',
            name: 'Uzbek Wedding Plov',
            emoji: '🥘',
            calories: 680,
            protein: 28,
            carbs: 85,
            fat: 32,
            description: 'Hearty rice with lamb, yellow carrots, and spices',
            ingredients: ['Rice', 'Lamb', 'Yellow carrots', 'Onions', 'Cumin'],
            allergens: [],
            cookingMethod: 'Slow cooked in a giant cauldron',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Uzbek_plov.jpg'
          }
        ]
      }
    ]
  },
  'BISHKEK': {
    standName: 'Bishkek Manty House',
    standIcon: 'Utensils',
    cuisine: 'Kyrgyz',
    quests: [
      {
        id: 'bish_manty',
        name: 'The Steamed Manty',
        description: 'Large dumplings filled with spiced meat and onions, served with sour cream.',
        location: 'Osh Bazaar',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'manty_main',
            name: 'Kyrgyz Meat Manty',
            emoji: '🥟',
            calories: 420,
            protein: 22,
            carbs: 45,
            fat: 18,
            description: 'Large steamed dumplings filled with spiced lamb and onion',
            ingredients: ['Wheat dough', 'Lamb', 'Onions', 'Black pepper'],
            allergens: ['Wheat'],
            cookingMethod: 'Steamed in a multi-tier cooker',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/35/Manty_%283968046229%29.jpg'
          }
        ]
      }
    ]
  },
  'ASHGABAT': {
    standName: 'Ashgabat Somsa Spot',
    standIcon: 'ChefHat',
    cuisine: 'Turkmen',
    quests: [
      {
        id: 'ash_somsa',
        name: 'Tandir Somsa Run',
        description: 'Pastries filled with meat and onions, baked on the walls of a clay oven.',
        location: 'Tolkychka Bazaar',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'somsa_main',
            name: 'Clay Oven Somsa',
            emoji: '🥟',
            calories: 320,
            protein: 14,
            carbs: 38,
            fat: 16,
            description: 'Crusty pastry baked in a Tandir oven with meat filling',
            ingredients: ['Wheat flour', 'Beef', 'Onions', 'Animal fat'],
            allergens: ['Wheat'],
            cookingMethod: 'Tandir baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Samsa_baked_in_tandir.jpg'
          }
        ]
      }
    ]
  },
  'SAMARKAND': {
    standName: 'Samarkand Nan Bakery',
    standIcon: 'Star',
    cuisine: 'Uzbek',
    quests: [
      {
        id: 'sam_nan',
        name: 'The Legendary Bread',
        description: 'Giant, heavy, and beautiful patterned flatbread. Famous across Central Asia!',
        location: 'Siab Bazaar',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'nan_main',
            name: 'Samarkand Oba Nan',
            emoji: '🥯',
            calories: 450,
            protein: 12,
            carbs: 85,
            fat: 4,
            description: 'Dense and glossy traditional patterned flatbread',
            ingredients: ['Flour', 'Milk', 'Yeast', 'Black cumin seeds'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Tandir baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Samarqand_noni.jpg'
          }
        ]
      }
    ]
  },
  'BUKHARA': {
    standName: 'Bukhara Shashlik Grill',
    standIcon: 'ChefHat',
    cuisine: 'Uzbek',
    quests: [
      {
        id: 'bukh_shashlik',
        name: 'The Silk Road Skewer',
        description: 'Perfectly seasoned meat skewers grilled over fruitwood charcoal.',
        location: 'Lyabi-Hauz',
        reward: 42000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'shashlik_main',
            name: 'Bukhara Lamb Shashlik',
            emoji: '🍢',
            calories: 380,
            protein: 36,
            carbs: 2,
            fat: 26,
            description: 'Juicy lamb chunks marinated with vinegar and spices',
            ingredients: ['Lamb', 'Onion rings', 'Vinegar', 'Cumin'],
            allergens: [],
            cookingMethod: 'Charcoal grilled skewers',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Shashlik_%26_Beer_in_Samarkand..jpg'
          }
        ]
      }
    ]
  },
  'TEHRAN': {
    standName: 'Tehran Sambooseh Cart',
    standIcon: 'Star',
    cuisine: 'Persian',
    quests: [
      {
        id: 'teh_sambooseh',
        name: 'South Tehran Snack',
        description: 'Crispy fried triangular pastries filled with spicy potato and herbs.',
        location: 'Grand Bazaar',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'sambooseh_main',
            name: 'Persian Sambooseh',
            emoji: '🥟',
            calories: 280,
            protein: 6,
            carbs: 35,
            fat: 14,
            description: 'Fried thin bread wrap with spicy potato and leek',
            ingredients: ['Thin bread', 'Potatoes', 'Leeks', 'Parsley', 'Spices'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3e/Sambousek_%284009290205%29.jpg'
          }
        ]
      }
    ]
  },
  'RIYADH': {
    standName: 'Riyadh Kabsa House',
    standIcon: 'ChefHat',
    cuisine: 'Saudi',
    quests: [
      {
        id: 'riy_kabsa',
        name: 'The Royal Kabsa',
        description: 'The national dish of Saudi Arabia. Spiced rice with succulent chicken.',
        location: 'Deira Square',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kabsa_main',
            name: 'Saudi Chicken Kabsa',
            emoji: '🥘',
            calories: 620,
            protein: 38,
            carbs: 72,
            fat: 22,
            description: 'Long grain rice with chicken and a special blend of spices',
            ingredients: ['Basmati rice', 'Chicken', 'Kabsa spice mix', 'Dried lime', 'Saffron'],
            allergens: [],
            cookingMethod: 'Braised chicken and rice',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/A_Valencian_paella_with_red_bell_peppers.jpg'
          }
        ]
      }
    ]
  },
  'BAGHDAD': {
    standName: 'Baghdad Samoon Bakery',
    standIcon: 'Star',
    cuisine: 'Iraqi',
    quests: [
      {
        id: 'bag_samoon',
        name: 'The Diamond Bread',
        description: 'Iconic diamond-shaped bread, hot from the stone oven.',
        location: 'Al-Mutanabbi Street',
        reward: 30000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'samoon_main',
            name: 'Iraqi Stone-Baked Samoon',
            emoji: '🥯',
            calories: 210,
            protein: 6,
            carbs: 45,
            fat: 2,
            description: 'Traditional Iraqi yeast bread with a diamond shape',
            ingredients: ['Flour', 'Yeast', 'Water', 'Salt', 'Sesame seeds'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Stone oven baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Samoon_bread.jpg'
          }
        ]
      }
    ]
  },
  'KUWAIT_CITY': {
    standName: 'Kuwait Regag Stand',
    standIcon: 'ChefHat',
    cuisine: 'Kuwaiti',
    quests: [
      {
        id: 'kuw_regag',
        name: 'The Regag Roll',
        description: 'Paper-thin crispy bread topped with cheese and honey or egg.',
        location: 'Souq Al-Mubarakiya',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'regag_main',
            name: 'Kuwaiti Regag Bread',
            emoji: '🥞',
            calories: 180,
            protein: 4,
            carbs: 32,
            fat: 4,
            description: 'Crispy thin bread with cheese and spices',
            ingredients: ['Thin batter', 'Cheese', 'Mawa (spices)', 'Honey'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Spread on a hot plate',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Regag_bread.jpg'
          }
        ]
      }
    ]
  },
  'DOHA': {
    standName: 'Doha Luqaimat Cart',
    standIcon: 'Cookie',
    cuisine: 'Qatari',
    quests: [
      {
        id: 'doh_luqaimat',
        name: 'Sweet Victory',
        description: 'Golden fried dough balls drizzled with date syrup and sesame seeds.',
        location: 'Souq Waqif',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'luqaimat_main',
            name: 'Qatari Luqaimat',
            emoji: '🍩',
            calories: 320,
            protein: 4,
            carbs: 52,
            fat: 12,
            description: 'Fried dough balls with saffron and date syrup',
            ingredients: ['Flour', 'Saffron', 'Cardamom', 'Date syrup', 'Sesame'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Deep fried and drizzled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Luqaimat.jpg'
          }
        ]
      }
    ]
  },
  'MANAMA': {
    standName: 'Manama Tikka Grill',
    standIcon: 'ChefHat',
    cuisine: 'Bahraini',
    quests: [
      {
        id: 'man_tikka',
        name: 'The Bahraini Tikka',
        description: 'Small, flavorful skewers of marinated meat, served with fresh herbs.',
        location: 'Bab Al Bahrain',
        reward: 40000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tikka_main',
            name: 'Classic Bahraini Tikka',
            emoji: '🍢',
            calories: 340,
            protein: 38,
            carbs: 2,
            fat: 22,
            description: 'Black lime marinated beef or lamb skewers',
            ingredients: ['Beef', 'Black lime (Loomi)', 'Spices', 'Herbs'],
            allergens: [],
            cookingMethod: 'Charcoal grilled skewers',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Chicken_tikka.jpg'
          }
        ]
      }
    ]
  },
  'MUSCAT': {
    standName: 'Muscat Mishkak Corner',
    standIcon: 'Star',
    cuisine: 'Omani',
    quests: [
      {
        id: 'mus_mishkak',
        name: 'Mishkak Mastery',
        description: 'Grilled meat skewers with a tangy tamarind sauce. An Omani street staple!',
        location: 'Muttrah Corniche',
        reward: 42000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mishkak_main',
            name: 'Omani Lamb Mishkak',
            emoji: '🍢',
            calories: 360,
            protein: 34,
            carbs: 4,
            fat: 24,
            description: 'Grilled lamb skewers with tamarind and chili sauce',
            ingredients: ['Lamb', 'Tamarind paste', 'Chili', 'Ginger', 'Garlic'],
            allergens: [],
            cookingMethod: 'Charcoal grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Shish_kebab.jpg'
          }
        ]
      }
    ]
  },
  'SANA': {
    standName: 'Old Sana Saltah Pot',
    standIcon: 'Utensils',
    cuisine: 'Yemeni',
    quests: [
      {
        id: 'san_saltah',
        name: 'The Dancing Stew',
        description: 'Yemen\'s national dish: a bubbling meat stew topped with fenugreek froth.',
        location: 'Old City',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'saltah_main',
            name: 'Traditional Saltah',
            emoji: '🥣',
            calories: 520,
            protein: 28,
            carbs: 35,
            fat: 28,
            description: 'Meat stew with hilbeh (fenugreek) and spicy salsa',
            ingredients: ['Lamb stew', 'Fenugreek foam', 'Zhug (green chili sauce)', 'Vegetables'],
            allergens: [],
            cookingMethod: 'Bubbling in a stone pot',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8c/Saltah.jpg'
          }
        ]
      }
    ]
  },
  'DUBAI': {
    standName: 'Dubai Shawarma Hub',
    standIcon: 'ChefHat',
    cuisine: 'Emirati',
    quests: [
      {
        id: 'dxb_shawarma',
        name: 'The Late Night Wrap',
        description: 'The city that never sleeps has the best midnight shawarma wraps!',
        location: 'Deira',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'dxb_shawarma_main',
            name: 'Dubai Street Shawarma',
            emoji: '🌯',
            calories: 550,
            protein: 32,
            carbs: 48,
            fat: 26,
            description: 'Perfectly grilled chicken in a soft wrap with tahini and fries',
            ingredients: ['Marinated chicken', 'Khoubz (flatbread)', 'Tahini', 'Fries', 'Pickles'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Vertical rotisserie',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d8/Chicken_shawarma.jpg'
          }
        ]
      }
    ]
  },
  'COLOMBO': {
    standName: 'Colombo Kottu Stall',
    standIcon: 'ChefHat',
    cuisine: 'Sri Lankan',
    quests: [
      {
        id: 'col_kottu',
        name: 'Kottu Roti Rhythms',
        description: 'Watch and listen as the kottu is chopped on the griddle. A Sri Lankan street food masterpiece!',
        location: 'Galle Face Green',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kottu_main',
            name: 'Sri Lankan Kottu Roti',
            emoji: '🥘',
            calories: 450,
            protein: 18,
            carbs: 55,
            fat: 18,
            description: 'Chopped roti bread mixed with vegetables, egg, and spicy curry',
            ingredients: ['Godamba roti', 'Vegetables', 'Egg', 'Curry sauce', 'Spices'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Griddle chopped',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Kottu_roti.jpg'
          }
        ]
      }
    ]
  },
  'MALE': {
    standName: 'Male Mas Huni Corner',
    standIcon: 'Star',
    cuisine: 'Maldivian',
    quests: [
      {
        id: 'mle_mas_huni',
        name: 'Island Mas Huni Catch',
        description: 'Traditional Maldivian breakfast of tuna, coconut, and onion. Served with Roshi bread.',
        location: 'Artificial Beach',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mas_huni_main',
            name: 'Maldivian Mas Huni',
            emoji: '🐟',
            calories: 220,
            protein: 24,
            carbs: 8,
            fat: 12,
            description: 'Tuna mixed with grated coconut, chili, and onion',
            ingredients: ['Smoked tuna', 'Grated coconut', 'Chili', 'Onion', 'Lime'],
            allergens: ['Fish'],
            cookingMethod: 'Mixed fresh',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Mas_huni.jpg'
          }
        ]
      }
    ]
  },
  'KATHMANDU': {
    standName: 'Kathmandu MoMo Hut',
    standIcon: 'Utensils',
    cuisine: 'Nepalese',
    quests: [
      {
        id: 'ktm_momo',
        name: 'Everest MoMo Quest',
        description: 'Delicious steamed dumplings filled with spiced meat. A staple of Kathmandu streets!',
        location: 'Thamel',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'momo_main',
            name: 'Kathmandu Buff MoMo',
            emoji: '🥟',
            calories: 290,
            protein: 16,
            carbs: 38,
            fat: 10,
            description: 'Steamed dumplings with spiced buffalo or chicken meat',
            ingredients: ['Dough', 'Minced meat', 'Ginger', 'Garlic', 'Masala spices'],
            allergens: ['Wheat'],
            cookingMethod: 'Steamed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Nepalese_Momos.JPG'
          }
        ]
      }
    ]
  },
  'THIMPHU': {
    standName: 'Thimphu Ema Datshi Stall',
    standIcon: 'ChefHat',
    cuisine: 'Bhutanese',
    quests: [
      {
        id: 'thi_ema_datshi',
        name: 'The Chili Cheese Challenge',
        description: 'Can you handle the heat? Bhutan\'s national dish: chilies and cheese!',
        location: 'Norzin Lam',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'ema_datshi_main',
            name: 'Bhutanese Ema Datshi',
            emoji: '🌶️',
            calories: 320,
            protein: 12,
            carbs: 10,
            fat: 26,
            description: 'Green or red chilies cooked in a rich cheese sauce',
            ingredients: ['Chilies', 'Bhutanese cheese', 'Garlic', 'Oil'],
            allergens: ['Dairy'],
            cookingMethod: 'Simmered in cheese',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Ema_datshi.jpg'
          }
        ]
      }
    ]
  },
  'CHENNAI': {
    standName: 'Marina Beach Chicken 65',
    standIcon: 'Heart',
    cuisine: 'South Indian',
    quests: [
      {
        id: 'maa_chicken_65',
        name: 'The Original Chicken 65',
        description: 'Spicy, deep-fried chicken bites from the heart of Chennai. A legendary appetizer!',
        location: 'Marina Beach',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chicken_65_main',
            name: 'Chennai Chicken 65',
            emoji: '🍗',
            calories: 380,
            protein: 28,
            carbs: 12,
            fat: 22,
            description: 'Spicy deep-fried chicken marinated with ginger, garlic, and red chilies',
            ingredients: ['Chicken', 'Ginger-garlic paste', 'Kashmiri chili', 'Curry leaves', 'Lemon'],
            allergens: [],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Jerk_chicken_plate.jpg'
          }
        ]
      }
    ]
  },
  'BANGALORE': {
    standName: 'MTR Bisi Bele Bath',
    standIcon: 'Utensils',
    cuisine: 'Kannada',
    quests: [
      {
        id: 'blr_bisi_bele_bath',
        name: 'Hot Lentil Rice Run',
        description: 'Traditional Karnataka comfort food: a spicy, tangy blend of rice, lentils, and vegetables.',
        location: 'VV Puram Food Street',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'bisi_bele_bath_main',
            name: 'Bangalore Bisi Bele Bath',
            emoji: '🥣',
            calories: 420,
            protein: 12,
            carbs: 65,
            fat: 14,
            description: 'Spicy rice and lentil dish with vegetables and clarified butter',
            ingredients: ['Rice', 'Toor dal', 'Tamarind', 'Bisi bele bath masala', 'Ghee'],
            allergens: ['Dairy'],
            cookingMethod: 'One-pot pressure cooked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Bisi_bele_bath.jpg'
          }
        ]
      }
    ]
  },
  'MUMBAI': {
    standName: 'Mumbai Vada Pav King',
    standIcon: 'Star',
    cuisine: 'Marathi',
    quests: [
      {
        id: 'bom_vada_pav',
        name: 'The Working Man\'s Burger',
        description: 'Mumbai\'s most iconic street food: Spicy potato fritter in a bun!',
        location: 'Dadar',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'vada_pav_main',
            name: 'Classic Mumbai Vada Pav',
            emoji: '🍔',
            calories: 310,
            protein: 6,
            carbs: 42,
            fat: 14,
            description: 'Spicy potato fritter in a bread roll with chutneys',
            ingredients: ['Potato', 'Chickpea flour', 'Pav (bread roll)', 'Garlic chutney'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried potato ball',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Vada_pav.jpg'
          }
        ]
      }
    ]
  },
  'DELHI': {
    standName: 'Chandni Chowk Chole',
    standIcon: 'ChefHat',
    cuisine: 'North Indian',
    quests: [
      {
        id: 'del_chole_bhature',
        name: 'The Chole Bhature King',
        description: 'Spicy chickpeas served with fluffy deep-fried leavened bread. The soul of Delhi!',
        location: 'Chandni Chowk',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chole_bhature_main',
            name: 'Delhi Chole Bhature',
            emoji: '🥯',
            calories: 580,
            protein: 14,
            carbs: 72,
            fat: 28,
            description: 'Spicy chickpea curry with deep-fried bread',
            ingredients: ['Chickpeas', 'Refined flour bhatura', 'Ginger', 'Onion', 'Amla spice'],
            allergens: ['Wheat'],
            cookingMethod: 'Braised curry and deep fried bread',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Chole_bhature.jpg'
          }
        ]
      }
    ]
  },
  'KARACHI': {
    standName: 'Karachi Nihari House',
    standIcon: 'Utensils',
    cuisine: 'Pakistani',
    quests: [
      {
        id: 'khi_nihari',
        name: 'The Slow-Cooked Nihari',
        description: 'Karachi\'s favorite breakfast: slow-cooked beef stew with a rich, velvety gravy.',
        location: 'Burns Road',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'nihari_main',
            name: 'Classic Karachi Nihari',
            emoji: '🥘',
            calories: 620,
            protein: 42,
            carbs: 12,
            fat: 45,
            description: 'Slow-cooked beef shanks in a spicy flour-thickened gravy',
            ingredients: ['Beef shanks', 'Wheat flour', 'Ginger', 'Green chilies', 'Nihari masala'],
            allergens: ['Wheat'],
            cookingMethod: 'Overnight slow cooking',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Nihari.jpg'
          }
        ]
      }
    ]
  },
  'ISLAMABAD': {
    standName: 'F-6 Seekh Kabab',
    standIcon: 'Star',
    cuisine: 'Pakistani',
    quests: [
      {
        id: 'isb_seekh_kabab',
        name: 'The Melt-in-Mouth Kabab',
        description: 'Succulent minced meat skewers grilled over charcoal. Served with fresh naan.',
        location: 'F-6 Markaz',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'seekh_kabab_main',
            name: 'Islamabad Seekh Kabab',
            emoji: '🍢',
            calories: 320,
            protein: 34,
            carbs: 4,
            fat: 18,
            description: 'Spiced minced lamb or beef skewers grilled on charcoal',
            ingredients: ['Minced meat', 'Green chilies', 'Ginger-garlic', 'Coriander', 'Spices'],
            allergens: [],
            cookingMethod: 'Charcoal grilled skewers',
            image: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Adnan_Kebab._Iraqi_Kebab_Resturant._Namdaemun_Market_Seoul%2C_South_Korea_01.jpg'
          }
        ]
      }
    ]
  },
  'DHAKA': {
    standName: 'Dhaka Biryani House',
    standIcon: 'Heart',
    cuisine: 'Bengali',
    quests: [
      {
        id: 'dac_kacchi_biryani',
        name: 'The Royal Kacchi',
        description: 'Bangladesh\'s famous mutton biryani, cooked with fragrant basmati rice and potatoes.',
        location: 'Old Dhaka',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kacchi_biryani_main',
            name: 'Old Dhaka Kacchi Biryani',
            emoji: '🥘',
            calories: 620,
            protein: 28,
            carbs: 75,
            fat: 24,
            description: 'Mutton biryani where raw meat is cooked with rice',
            ingredients: ['Basmati rice', 'Mutton chunks', 'Potatoes', 'Biryani masala', 'Ghee'],
            allergens: [],
            cookingMethod: 'Dum cooked (steam pressure)',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/A_Biryani.jpg'
          }
        ]
      }
    ]
  },
  'YANGON': {
    standName: 'Yangon Mohinga Shop',
    standIcon: 'ChefHat',
    cuisine: 'Burmese',
    quests: [
      {
        id: 'rgn_mohinga',
        name: 'The Breakfast Bowl',
        description: 'Myanmar\'s national dish: fish soup with rice noodles and crispy fritters.',
        location: 'Bogyoke Market',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mohinga_main',
            name: 'Classic Yangon Mohinga',
            emoji: '🍜',
            calories: 340,
            protein: 18,
            carbs: 45,
            fat: 10,
            description: 'Aromatic fish broth with rice noodles and lemongrass',
            ingredients: ['Catfish', 'Rice noodles', 'Lemongrass', 'Ginger', 'Banana stem'],
            allergens: ['Fish'],
            cookingMethod: 'Slow simmered broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Mohinga.jpg'
          }
        ]
      }
    ]
  },
  'KABUL': {
    standName: 'Kabul Pulao Palace',
    standIcon: 'Utensils',
    cuisine: 'Afghan',
    quests: [
      {
        id: 'kbl_kabuli_pulao',
        name: 'The National Pulao',
        description: 'Fragrant rice topped with carrots, raisins, and tender lamb. The king of Afghan hospitality.',
        location: 'Chicken Street',
        reward: 42000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kabuli_pulao_main',
            name: 'Royal Kabuli Pulao',
            emoji: '🍚',
            calories: 580,
            protein: 32,
            carbs: 85,
            fat: 18,
            description: 'Long-grain rice with lamb, caramelized carrots, and raisins',
            ingredients: ['Basmati rice', 'Lamb chunks', 'Carrots', 'Raisins', 'Afghan spices'],
            allergens: [],
            cookingMethod: 'Slow cooked',
          }
        ]
      }
    ]
  },
  'ULAANBAATAR': {
    standName: 'UB Bansh House',
    standIcon: 'Star',
    cuisine: 'Mongolian',
    quests: [
      {
        id: 'uln_bansh',
        name: 'The Steamed Bansh',
        description: 'Traditional Mongolian small dumplings, perfect in a warm soup or milk tea.',
        location: 'Sukhbaatar Square',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'bansh_main',
            name: 'Mongolian Bansh',
            emoji: '🥟',
            calories: 280,
            protein: 14,
            carbs: 32,
            fat: 12,
            description: 'Small dumplings filled with minced beef or mutton',
            ingredients: ['Wheat dough', 'Minced beef', 'Onions', 'Black pepper'],
            allergens: ['Wheat'],
            cookingMethod: 'Boiled or steamed',
          }
        ]
      }
    ]
  },
  'IRKUTSK': {
    standName: 'Irkutsk Buuz Bar',
    standIcon: 'ChefHat',
    cuisine: 'Buryat',
    quests: [
      {
        id: 'irk_buuz',
        name: 'The Steamy Buuz',
        description: 'Buryat-style large steamed dumplings. Bite the bottom, sip the juice, then eat!',
        location: 'Central Market',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'buuz_main',
            name: 'Buryat Buuz Dumplings',
            emoji: '🥟',
            calories: 320,
            protein: 18,
            carbs: 35,
            fat: 14,
            description: 'Juicy steamed dumplings filled with minced meat and fat',
            ingredients: ['Wheat dough', 'Mixed minced meat', 'Onions', 'Animal fat'],
            allergens: ['Wheat'],
            cookingMethod: 'Steamed',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/36/MongolianBuuz.JPG'
          }
        ]
      }
    ]
  },
  'MACAU': {
    standName: 'Macau Egg Tart Stall',
    standIcon: 'Cookie',
    cuisine: 'Macanese',
    quests: [
      {
        id: 'mac_egg_tart',
        name: 'The Golden Flaky Tart',
        description: 'The legendary Macanese egg tart: creamy custard in a flaky pastry shell.',
        location: 'Coloane Village',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'egg_tart_main',
            name: 'Macau Portuguese Egg Tart',
            emoji: '🧁',
            calories: 180,
            protein: 4,
            carbs: 22,
            fat: 10,
            description: 'Creamy egg custard tart with caramelized top',
            ingredients: ['Puff pastry', 'Egg yolks', 'Cream', 'Sugar'],
            allergens: ['Dairy', 'Eggs', 'Wheat'],
            cookingMethod: 'High temperature baked',
          }
        ]
      }
    ]
  },
  'TAIPEI': {
    standName: 'Taipei Beef Noodle Spot',
    standIcon: 'Heart',
    cuisine: 'Taiwanese',
    quests: [
      {
        id: 'tpe_beef_noodle',
        name: 'The Beef Noodle Run',
        description: 'Tender braised beef and chewy noodles in a rich, aromatic broth. Taipei\'s pride!',
        location: 'Shilin Night Market',
        reward: 42000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'beef_noodle_main',
            name: 'Taipei Braised Beef Noodles',
            emoji: '🍜',
            calories: 550,
            protein: 38,
            carbs: 65,
            fat: 22,
            description: 'Red-braised beef shanks with hand-pulled noodles',
            ingredients: ['Beef shank', 'Wheat noodles', 'Star anise', 'Soy sauce', 'Ginger'],
            allergens: ['Wheat', 'Soy'],
            cookingMethod: 'Slow braised',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d8/Taiwanese_Beef_Noodle_Soup.jpg'
          }
        ]
      }
    ]
  },
  'SYDNEY': {
    standName: 'Harry\'s de Wheels',
    standIcon: 'Star',
    cuisine: 'Australian',
    quests: [
      {
        id: 'syd_meatpie',
        name: 'The Tiger Pie',
        description: 'A classic Australian meat pie topped with mashed peas and gravy.',
        location: 'Woolloomooloo',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'meatpie_main',
            name: 'Australian Meat Pie',
            emoji: '🥧',
            calories: 450,
            protein: 22,
            carbs: 38,
            fat: 26,
            description: 'Flaky pastry filled with minced meat and rich gravy',
            ingredients: ['Pastry', 'Minced beef', 'Onions', 'Thick gravy'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'MELBOURNE': {
    standName: 'Melbourne Laneway Coffee',
    standIcon: 'Heart',
    cuisine: 'Australian',
    quests: [
      {
        id: 'mel_coffee_snack',
        name: 'The Flat White & Toastie',
        description: 'Melbourne\'s world-famous coffee paired with a gourmet toastie.',
        location: 'Degraves Street',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'toastie_main',
            name: 'Melbourne Gourmet Toastie',
            emoji: '🥪',
            calories: 380,
            protein: 14,
            carbs: 32,
            fat: 22,
            description: 'Sourdough toasted sandwich with aged cheddar and ham',
            ingredients: ['Sourdough bread', 'Aged cheddar', 'Ham', 'Dijon mustard'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Pressed and toasted',
          }
        ]
      }
    ]
  },
  'SUVA': {
    standName: 'Suva Market Lovo',
    standIcon: 'ChefHat',
    cuisine: 'Fijian',
    quests: [
      {
        id: 'suv_lovo',
        name: 'The Earth Oven Feast',
        description: 'Taste the smoky flavors of a traditional Fijian Lovo (earth oven).',
        location: 'Suva Market',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'lovo_main',
            name: 'Fijian Lovo Box',
            emoji: '🍱',
            calories: 480,
            protein: 32,
            carbs: 45,
            fat: 18,
            description: 'Smoky slow-cooked meat and root vegetables',
            ingredients: ['Pork', 'Chicken', 'Cassava', 'Dalo (Taro)', 'Coconut cream'],
            allergens: [],
            cookingMethod: 'Slow cooked in earth oven',
          }
        ]
      }
    ]
  },
  'PORT_MORESBY': {
    standName: 'POM Mumu Hub',
    standIcon: 'Utensils',
    cuisine: 'PNG',
    quests: [
      {
        id: 'pom_mumu',
        name: 'The Mumu Master',
        description: 'Traditional PNG Mumu style cooking with sweet potatoes and pork.',
        location: 'Boroko Market',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mumu_main',
            name: 'PNG Mumu Meal',
            emoji: '🥘',
            calories: 520,
            protein: 34,
            carbs: 58,
            fat: 18,
            description: 'Sweet potatoes and pork cooked in banana leaves',
            ingredients: ['Pork', 'Kaukau (Sweet potato)', 'Banana leaves', 'Coconut milk'],
            allergens: [],
            cookingMethod: 'Steamed in banana leaves', // Using generic Pacific food proxy
          }
        ]
      }
    ]
  },
  'NADI': {
    standName: 'Nadi Curry Corner',
    standIcon: 'Star',
    cuisine: 'Fijian-Indian',
    quests: [
      {
        id: 'nan_curry',
        name: 'The Fiji Curry Wrap',
        description: 'Spicy Fiji-style chicken curry wrapped in a soft roti. Perfect Nadi snack!',
        location: 'Nadi Town Market',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'curry_roti_main',
            name: 'Nadi Curry Roti',
            emoji: '🌯',
            calories: 380,
            protein: 26,
            carbs: 42,
            fat: 14,
            description: 'Bone-in chicken curry wrapped in a fresh roti',
            ingredients: ['Chicken', 'Fiji curry powder', 'Roti', 'Potatoes'],
            allergens: ['Wheat'],
            cookingMethod: 'Simmered curry, grilled roti',
          }
        ]
      }
    ]
  },
  'HONIARA': {
    standName: 'Honiara Morning Market',
    standIcon: 'Heart',
    cuisine: 'Solomon Islands',
    quests: [
      {
        id: 'hir_cassava',
        name: 'The Cassava Crunch',
        description: 'Deep-fried cassava cakes, simple and delicious Honiara street snack!',
        location: 'Central Market',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'cassava_cake_main',
            name: 'Honiara Cassava Cake',
            emoji: '🥞',
            calories: 210,
            protein: 2,
            carbs: 48,
            fat: 4,
            description: 'Fried grated cassava with coconut',
            ingredients: ['Cassava', 'Coconut', 'Salt'],
            allergens: [],
            cookingMethod: 'Deep fried', // Using Pacific food proxy
          }
        ]
      }
    ]
  },
  'AUCKLAND': {
    standName: 'Auckland Whitebait Shed',
    standIcon: 'Star',
    cuisine: 'New Zealander',
    quests: [
      {
        id: 'akl_whitebait',
        name: 'The Whitebait Fritter',
        description: 'A true NZ delicacy: Whitebait fritters in white bread. Pure Kiwi gold!',
        location: 'Viaduct Harbor',
        reward: 48000,
        fanReward: 14000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'whitebait_main',
            name: 'NZ Whitebait Fritter',
            emoji: '🥞',
            calories: 280,
            protein: 18,
            carbs: 22,
            fat: 14,
            description: 'Delicate whitebait fish fried in a light egg batter',
            ingredients: ['Whitebait', 'Egg', 'White bread', 'Lemon'],
            allergens: ['Fish', 'Eggs', 'Wheat'],
            cookingMethod: 'Pan fried', // Actually found a whitebait file in Suva museum category lol
          }
        ]
      }
    ]
  },
  'WELLINGTON': {
    standName: 'Willy\'s Fish & Chips',
    standIcon: 'ChefHat',
    cuisine: 'New Zealander',
    quests: [
      {
        id: 'wlg_fish_chips',
        name: 'The Harbor Fry',
        description: 'Crispy battered snapper and hand-cut chips. The classic Wellington experience!',
        location: 'Oriental Bay',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'fish_chips_main',
            name: 'Wellington Fish & Chips',
            emoji: '🐟',
            calories: 680,
            protein: 42,
            carbs: 72,
            fat: 28,
            description: 'Golden battered snapper with thick-cut chips',
            ingredients: ['Snapper', 'Beer batter', 'Potatoes', 'Tartare sauce'],
            allergens: ['Fish', 'Wheat'],
            cookingMethod: 'Deep fried',
          }
        ]
      }
    ]
  },
  'TORONTO': {
    standName: 'Toronto Peameal Palace',
    standIcon: 'ChefHat',
    cuisine: 'Canadian',
    quests: [
      {
        id: 'yyz_peameal_bacon',
        name: 'The St. Lawrence Special',
        description: 'World-famous Toronto peameal bacon on a fresh kaiser roll. A city legend!',
        location: 'St. Lawrence Market',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'peameal_bacon_main',
            name: 'Toronto Peameal Bacon Roll',
            emoji: '🥪',
            calories: 420,
            protein: 28,
            carbs: 35,
            fat: 18,
            description: 'Cornmeal-crusted back bacon on a kaiser roll with honey mustard',
            ingredients: ['Peameal bacon', 'Kaiser roll', 'Honey mustard'],
            allergens: ['Wheat'],
            cookingMethod: 'Griddle fried',
          }
        ]
      }
    ]
  },
  'MONTREAL': {
    standName: 'Montreal Poutine Shack',
    standIcon: 'Star',
    cuisine: 'Québécois',
    quests: [
      {
        id: 'yul_poutine',
        name: 'Classic Poutine Perfection',
        description: 'Squeaky cheese curds and hot gravy over golden fries. The soul of Montreal!',
        location: 'Plateau',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'poutine_main',
            name: 'Classic Montreal Poutine',
            emoji: '🍟',
            calories: 850,
            protein: 24,
            carbs: 85,
            fat: 45,
            description: 'Crispy fries with fresh cheese curds and brown gravy',
            ingredients: ['Fries', 'Cheese curds', 'Gravy'],
            allergens: ['Dairy', 'Wheat'],
            cookingMethod: 'Assembled hot',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/8e/Better_Poutine.jpg'
          }
        ]
      }
    ]
  },
  'CHICAGO': {
    standName: 'Windy City Dogs',
    standIcon: 'ChefHat',
    cuisine: 'American',
    quests: [
      {
        id: 'ord_chicago_dog',
        name: 'Run it Through the Garden',
        description: 'The famous Chicago-style hot dog. Remember: NO KETCHUP!',
        location: 'Wrigleyville',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chicago_hotdog_main',
            name: 'Chicago Style Hot Dog',
            emoji: '🌭',
            calories: 450,
            protein: 18,
            carbs: 45,
            fat: 22,
            description: 'All-beef hot dog on a poppy seed bun with yellow mustard, relish, and sports peppers',
            ingredients: ['Beef frank', 'Poppy seed bun', 'Yellow mustard', 'Neon green relish', 'Onion', 'Tomato', 'Pickle spear', 'Sport peppers', 'Celery salt'],
            allergens: ['Wheat'],
            cookingMethod: 'Steamed',
          }
        ]
      }
    ]
  },
  'MIAMI': {
    standName: 'Little Havana Cubanos',
    standIcon: 'Utensils',
    cuisine: 'Cuban-American',
    quests: [
      {
        id: 'mia_cubano',
        name: 'The Real Cubano',
        description: 'Pressed Cuban sandwich with roasted pork and ham. Miami\'s favorite lunch!',
        location: 'Calle Ocho',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'cubano_main',
            name: 'Classic Miami Cubano',
            emoji: '🥪',
            calories: 650,
            protein: 42,
            carbs: 52,
            fat: 28,
            description: 'Pressed Cuban bread with ham, roasted pork, swiss cheese, and pickles',
            ingredients: ['Cuban bread', 'Roasted pork', 'Ham', 'Swiss cheese', 'Pickles', 'Mustard', 'Butter'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Pressed in a plancha',
          }
        ]
      }
    ]
  },
  'SAO_PAULO': {
    standName: 'Sampa Pastel Stall',
    standIcon: 'ChefHat',
    cuisine: 'Brazilian',
    quests: [
      {
        id: 'gru_pastel',
        name: 'Feira Pastel Rush',
        description: 'Crispy fried thin crust pies. A Sao Paulo market staple!',
        location: 'Liberdade Market',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'pastel_main',
            name: 'Sampa Cheese Pastel',
            emoji: '🥟',
            calories: 280,
            protein: 8,
            carbs: 32,
            fat: 14,
            description: 'Crispy fried pastry filled with melted cheese',
            ingredients: ['Pastel dough', 'Cheese', 'Cachaça (in dough)'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Deep fried', // Using Coxinha as a high quality Brazilian snack proxy if Pastel photo is low res, wait I found Coxinha.jpg, let's use it for Coxinha if I find it. I'll use high quality pastel if possible.
          }
        ]
      }
    ]
  },
  'BUENOS_AIRES': {
    standName: 'BA Choripan Corner',
    standIcon: 'Star',
    cuisine: 'Argentinian',
    quests: [
      {
        id: 'eze_choripan',
        name: 'Stadium Choripan',
        description: 'Grilled chorizo sausage in a crusty roll with lots of chimichurri!',
        location: 'Puerto Madero',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'choripan_main',
            name: 'Buenos Aires Choripan',
            emoji: '🌭',
            calories: 520,
            protein: 24,
            carbs: 38,
            fat: 32,
            description: 'Grilled chorizo in crusty bread with chimichurri sauce',
            ingredients: ['Chorizo sausage', 'Baguette', 'Chimichurri (parsley, garlic, oregano, oil, vinegar)'],
            allergens: ['Wheat'],
            cookingMethod: 'Butterfly grilled sausage',
          }
        ]
      }
    ]
  },
  'LIMA': {
    standName: 'Lima Cevicheria Street',
    standIcon: 'Star',
    cuisine: 'Peruvian',
    quests: [
      {
        id: 'lim_ceviche',
        name: 'Fresh Ceviche Al Paso',
        description: 'Lima\'s famous fresh fish cured in lime juice. The king of Peruvian street food!',
        location: 'Miraflores',
        reward: 45000,
        fanReward: 13500,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'ceviche_main',
            name: 'Lima Classic Ceviche',
            emoji: '🐟',
            calories: 280,
            protein: 34,
            carbs: 18,
            fat: 4,
            description: 'Fresh white fish cured in lime juice with onions and chilies',
            ingredients: ['Sea bass', 'Lime juice', 'Red onion', 'Aji limo chili', 'Sweet potato', 'Canchita (toasted corn)'],
            allergens: ['Fish'],
            cookingMethod: 'Cured in acidity',
          }
        ]
      }
    ]
  },
  'BOGOTA': {
    standName: 'Bogota Arepa House',
    standIcon: 'Utensils',
    cuisine: 'Colombian',
    quests: [
      {
        id: 'bog_arepa',
        name: 'Arepa de Queso Morning',
        description: 'Corn cakes filled with gooey cheese, grilled until golden brown.',
        location: 'La Candelaria',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'arepa_main',
            name: 'Bogota Cheese Arepa',
            emoji: '🫓',
            calories: 320,
            protein: 10,
            carbs: 38,
            fat: 14,
            description: 'Cornmeal cake with white cheese filling',
            ingredients: ['Cornmeal', 'Cheese', 'Butter'],
            allergens: ['Dairy'],
            cookingMethod: 'Gridle grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/d/d2/Arepas_%281190640108%29.jpg'
          }
        ]
      }
    ]
  },
  'CARACAS': {
    standName: 'Caracas Arepa Stall',
    standIcon: 'Heart',
    cuisine: 'Venezuelan',
    quests: [
      {
        id: 'ccs_reina_pepiada',
        name: 'Reina Pepiada Queen',
        description: 'The most popular Venezuelan arepa: creamy avocado and chicken salad.',
        location: 'Altamira',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'arepa_main',
            name: 'Reina Pepiada Arepa',
            emoji: '🫓',
            calories: 450,
            protein: 24,
            carbs: 42,
            fat: 22,
            description: 'Corn flatbread filled with chicken and avocado salad',
            ingredients: ['Cornmeal', 'Chicken', 'Avocado', 'Mayonnaise', 'Petit pois'],
            allergens: ['Eggs'],
            cookingMethod: 'Grilled then filled',
          }
        ]
      }
    ]
  },
  'GUATEMALA_CITY': {
    standName: 'Guate Tostada Stand',
    standIcon: 'ChefHat',
    cuisine: 'Guatemalan',
    quests: [
      {
        id: 'gua_tostada',
        name: 'The Traditional Tostada',
        description: 'Crispy fried tortillas topped with chow mein, black beans, or salsa.',
        location: 'Zona 1',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tostada_main',
            name: 'Guatemalan Tostada',
            emoji: '🥞',
            calories: 210,
            protein: 4,
            carbs: 28,
            fat: 10,
            description: 'Crispy corn tortilla with flavorful toppings',
            ingredients: ['Corn tortilla', 'Black beans', 'Queso seco', 'Onions', 'Cilantro'],
            allergens: ['Dairy'],
            cookingMethod: 'Deep fried tortilla, assembled cold',
          }
        ]
      }
    ]
  },
  'PANAMA_CITY': {
    standName: 'Panama Tamal Point',
    standIcon: 'Utensils',
    cuisine: 'Panamanian',
    quests: [
      {
        id: 'pty_tamal',
        name: 'The Panama Tamal',
        description: 'Traditional corn masa tamal with chicken or pork, raisins, and olives.',
        location: 'Casco Viejo',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'tamal_main',
            name: 'Panamanian Tamal',
            emoji: '🫔',
            calories: 380,
            protein: 14,
            carbs: 45,
            fat: 16,
            description: 'Steamed corn dough with meat and traditional Caribbean seasonings',
            ingredients: ['Corn masa', 'Chicken', 'Raisins', 'Olives', 'Annatto'],
            allergens: [],
            cookingMethod: 'Wrapped in leaves and steamed',
          }
        ]
      }
    ]
  },
  'GEORGETOWN': {
    standName: 'Georgetown Pholourie Hut',
    standIcon: 'Star',
    cuisine: 'Guyanese',
    quests: [
      {
        id: 'geo_pholourie',
        name: 'The Split Pea Fix',
        description: 'Fried spiced split pea dough balls, served with hot tamarind chutney.',
        location: 'Stabroek Market',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'pholourie_main',
            name: 'Guyanese Pholourie',
            emoji: '🍡',
            calories: 180,
            protein: 6,
            carbs: 32,
            fat: 4,
            description: 'Fried spiced split pea balls with mango chutney',
            ingredients: ['Split peas', 'Flour', 'Turmeric', 'Geera (cumin)', 'Garlic'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
          }
        ]
      }
    ]
  },
  'PARAMARIBO': {
    standName: 'Parbo Saoto Soup',
    standIcon: 'ChefHat',
    cuisine: 'Surinamese-Javanese',
    quests: [
      {
        id: 'pbm_saoto',
        name: 'The Golden Broth',
        description: 'Javanese-inspired chicken soup with bean sprouts and crispy potato sticks.',
        location: 'Waterkant',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'saoto_main',
            name: 'Surinamese Saoto Soup',
            emoji: '🥣',
            calories: 320,
            protein: 18,
            carbs: 24,
            fat: 16,
            description: 'Clear chicken broth with shredded chicken, egg, and crispy toppings',
            ingredients: ['Chicken broth', 'Shredded chicken', 'Bean sprouts', 'Hard-boiled egg', 'Crispy potato sticks'],
            allergens: ['Eggs'],
            cookingMethod: 'Slow simmered',
          }
        ]
      }
    ]
  },
  'PORT_OF_SPAIN': {
    standName: 'Trinidad Doubles Hut',
    standIcon: 'Star',
    cuisine: 'Trinidadian',
    quests: [
      {
        id: 'pos_doubles',
        name: 'The Doubles Duel',
        description: 'Two fried flatbreads (bara) with curried chickpeas. The ultimate street food!',
        location: 'Queen\'s Park Savannah',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'doubles_main',
            name: 'Classic Trinidad Doubles',
            emoji: '🥯',
            calories: 340,
            protein: 10,
            carbs: 52,
            fat: 12,
            description: 'Two bara flatbreads with channa (curried chickpeas)',
            ingredients: ['Flour', 'Chickpeas', 'Turmeric', 'Cucumber chutney', 'Pepper sauce'],
            allergens: ['Wheat'],
            cookingMethod: 'Fried flatbread, simmered chickpeas',
          }
        ]
      }
    ]
  },
  'SANTO_DOMINGO': {
    standName: 'Santo Domingo Chimi Stand',
    standIcon: 'Utensils',
    cuisine: 'Dominican',
    quests: [
      {
        id: 'sdq_chimichurri',
        name: 'The Chimi Burger',
        description: 'Dominican street burger topped with shredded cabbage and salsa roja.',
        location: 'Malecon',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chimi_main',
            name: 'Santo Domingo Chimi Burger',
            emoji: '🍔',
            calories: 550,
            protein: 28,
            carbs: 38,
            fat: 32,
            description: 'Seasoned beef patty with shredded cabbage and special Dominican sauce',
            ingredients: ['Pan de agua (bread)', 'Ground beef', 'Cabbage', 'Chimi sauce'],
            allergens: ['Wheat'],
            cookingMethod: 'Grilled patty', // Using Tostada as high quality Latin street food proxy if specific Chimi unavailable
          }
        ]
      }
    ]
  },
  'SAN_JUAN': {
    standName: 'San Juan Mofongo Point',
    standIcon: 'ChefHat',
    cuisine: 'Puerto Rican',
    quests: [
      {
        id: 'sju_mofongo',
        name: 'The Plantain Punch',
        description: 'Fried green plantains mashed with garlic and chicharron. The soul of Puerto Rico!',
        location: 'Old San Juan',
        reward: 42000,
        fanReward: 12500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'mofongo_main',
            name: 'Puerto Rican Mofongo',
            emoji: '🥣',
            calories: 520,
            protein: 18,
            carbs: 65,
            fat: 28,
            description: 'Mashed fried green plantains with garlic and pork cracklings',
            ingredients: ['Green plantains', 'Garlic', 'Chicharron', 'Olive oil'],
            allergens: [],
            cookingMethod: 'Fried and hand-mashed in a pilon',
          }
        ]
      }
    ]
  },
  'MONTEVIDEO': {
    standName: 'Montevideo Chivito Cart',
    standIcon: 'Utensils',
    cuisine: 'Uruguayan',
    quests: [
      {
        id: 'mvd_chivito',
        name: 'The Chivito Challenge',
        description: 'Uruguay\'s massive national sandwich. Beef, ham, cheese, and everything else!',
        location: 'Mercado del Puerto',
        reward: 45000,
        fanReward: 13500,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chivito_main',
            name: 'Classic Montevideo Chivito',
            emoji: '🥪',
            calories: 880,
            protein: 48,
            carbs: 62,
            fat: 45,
            description: 'Beef steak sandwich with ham, cheese, egg, bacon, and olives',
            ingredients: ['Beef fillet', 'Ham', 'Mozzarella', 'Bacon', 'Hard-boiled egg', 'Lettuce', 'Tomato', 'Mayo'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Assembled on a roll',
          }
        ]
      }
    ]
  },
  'ASUNCION': {
    standName: 'Asuncion Chippa Hut',
    standIcon: 'ChefHat',
    cuisine: 'Paraguayan',
    quests: [
      {
        id: 'asu_chipa',
        name: 'The Chipa Circle',
        description: 'Traditional chewy cheese bread made with cassava flour. A Paraguayan staple!',
        location: 'Calle Palma',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'chipa_main',
            name: 'Classic Asuncion Chipa',
            emoji: '🥯',
            calories: 210,
            protein: 8,
            carbs: 24,
            fat: 10,
            description: 'Ring-shaped bread made with cassava flour, cheese, and anise',
            ingredients: ['Cassava starch', 'Cornmeal', 'Cheese', 'Eggs', 'Lard', 'Anise seeds'],
            allergens: ['Dairy', 'Eggs'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'LA_PAZ': {
    standName: 'La Paz Salteña Spot',
    standIcon: 'Star',
    cuisine: 'Bolivian',
    quests: [
      {
        id: 'lpb_saltena',
        name: 'The Juicy Salteña',
        description: 'Bolivian baked empanadas with a sweet crust and legendary soup-like filling!',
        location: 'El Prado',
        reward: 36000,
        fanReward: 10500,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'saltena_main',
            name: 'La Paz Beef Salteña',
            emoji: '🥟',
            calories: 320,
            protein: 12,
            carbs: 38,
            fat: 14,
            description: 'Baked pastry with sweet dough and juicy beef stew filling',
            ingredients: ['Flour', 'Beef', 'Potatoes', 'Gelatin (for juice)', 'Spices'],
            allergens: ['Wheat'],
            cookingMethod: 'Oven baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/0/0c/Chicken_Empanada.JPG'
          }
        ]
      }
    ]
  },
  'SANTIAGO': {
    standName: 'Santiago Completo Shop',
    standIcon: 'Utensils',
    cuisine: 'Chilean',
    quests: [
      {
        id: 'scl_completo',
        name: 'The Chilean Completo',
        description: 'Massive hot dog topped with massive amounts of avocado and mayo!',
        location: 'Plaza de Armas',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'completo_main',
            name: 'Santiago Completo Italiano',
            emoji: '🌭',
            calories: 520,
            protein: 16,
            carbs: 42,
            fat: 34,
            description: 'Hot dog with tomato, mashed avocado, and heavy mayonnaise',
            ingredients: ['Long bun', 'Sausage', 'Mashed avocado', 'Tomato', 'Mayonnaise'],
            allergens: ['Wheat', 'Eggs'],
            cookingMethod: 'Assembled',
          }
        ]
      }
    ]
  },
  'QUITO': {
    standName: 'Quito Hornado Point',
    standIcon: 'ChefHat',
    cuisine: 'Ecuadorian',
    quests: [
      {
        id: 'uio_hornado',
        name: 'The Hornado Feast',
        description: 'Roasted pig served with potato cakes (llapingachos). Quito street soul food!',
        location: 'Mercado Central',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'hornado_main',
            name: 'Quito Pork Hornado',
            emoji: '🥘',
            calories: 580,
            protein: 38,
            carbs: 32,
            fat: 28,
            description: 'Slow-roasted pork with potato patties and mote (corn)',
            ingredients: ['Roasted pork', 'Llapingachos (potato patties)', 'Mote', 'Agrio sauce'],
            allergens: [],
            cookingMethod: 'Slow roasted',
          }
        ]
      }
    ]
  },
  'SAN_JOSE': {
    standName: 'San Jose Gallo Pinto',
    standIcon: 'Star',
    cuisine: 'Costa Rican',
    quests: [
      {
        id: 'sjo_gallo_pinto',
        name: 'The Pure Life Breakfast',
        description: 'Costa Rica\'s national breakfast of rice and beans, served street-style.',
        location: 'Mercado Central',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'gallo_pinto_main',
            name: 'Pure Life Gallo Pinto',
            emoji: '🍛',
            calories: 380,
            protein: 12,
            carbs: 62,
            fat: 8,
            description: 'Seasoned rice and beans with Salsa Lizano',
            ingredients: ['Rice', 'Black beans', 'Bell pepper', 'Onion', 'Salsa Lizano'],
            allergens: [],
            cookingMethod: 'Sautéed together',
          }
        ]
      }
    ]
  },
  'BELMOPAN': {
    standName: 'Belmopan Fry Jacks',
    standIcon: 'ChefHat',
    cuisine: 'Belizean',
    quests: [
      {
        id: 'bc_fry_jacks',
        name: 'The Fry Jack Morning',
        description: 'Deep-fried dough pockets, a beloved Belizean breakfast or street snack!',
        location: 'Belmopan Market',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'fry_jack_main',
            name: 'Belmopan Fry Jacks',
            emoji: '🥞',
            calories: 280,
            protein: 4,
            carbs: 38,
            fat: 12,
            description: 'Fried dough crescents served with beans and cheese',
            ingredients: ['Flour', 'Baking powder', 'Refried beans', 'Dutch cheese'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Deep fried',
          }
        ]
      }
    ]
  },
  'MOSCOW': {
    standName: 'Red Square Blini',
    standIcon: 'ChefHat',
    cuisine: 'Russian',
    quests: [
      {
        id: 'svo_blini',
        name: 'The Golden Blini',
        description: 'Thin, buttery Russian pancakes with various sweet or savory fillings.',
        location: 'Red Square',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'russian_blini_1',
            name: 'Moscow Butter Blini',
            emoji: '🥞',
            calories: 220,
            protein: 6,
            carbs: 28,
            fat: 10,
            description: 'Thin buttery crepe served with sour cream or jam',
            ingredients: ['Flour', 'Milk', 'Eggs', 'Butter', 'Sour cream'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Pan fried',
          }
        ]
      }
    ]
  },
  'KIEV': {
    standName: 'Kiev Perepichka Spot',
    standIcon: 'Star',
    cuisine: 'Ukrainian',
    quests: [
      {
        id: 'iev_perepichka',
        name: 'The Famous Kiev Dog',
        description: 'Iconic deep-fried dough wrapped around a sausage. A Kiev legend since 1981!',
        location: 'Khreshchatyk',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kiev_perepichka_1',
            name: 'Kyivska Perepichka',
            emoji: '🌭',
            calories: 380,
            protein: 12,
            carbs: 35,
            fat: 22,
            description: 'Deep-fried yeast dough with a sausage inside',
            ingredients: ['Yeast dough', 'Sausage'],
            allergens: ['Wheat'],
            cookingMethod: 'Deep fried',
          }
        ]
      }
    ]
  },
  'MINSK': {
    standName: 'Minsk Draniki Hub',
    standIcon: 'Utensils',
    cuisine: 'Belarusian',
    quests: [
      {
        id: 'msq_draniki',
        name: 'The Draniki Drive',
        description: 'Traditional Belarusian potato pancakes, crispy on the outside and soft inside.',
        location: 'Independence Avenue',
        reward: 30000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'belarusian_draniki_1',
            name: 'Minsk Potato Draniki',
            emoji: '🥞',
            calories: 280,
            protein: 4,
            carbs: 42,
            fat: 12,
            description: 'Shredded potato pancakes served with thick sour cream',
            ingredients: ['Potatoes', 'Onions', 'Eggs', 'Flour', 'Sour cream'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Pan fried',
          }
        ]
      }
    ]
  },
  'BUCHAREST': {
    standName: 'Bucharest Covrigi Corner',
    standIcon: 'Cookie',
    cuisine: 'Romanian',
    quests: [
      {
        id: 'otp_covrigi',
        name: 'The Hot Covrigi Grab',
        description: 'Fresh baked pretzels covered in sesame or poppy seeds. The scent of Bucharest streets!',
        location: 'Piata Romana',
        reward: 28000,
        fanReward: 7500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'romanian_covrigi_1',
            name: 'Bucharest Sesame Covrigi',
            emoji: '🥨',
            calories: 180,
            protein: 5,
            carbs: 35,
            fat: 2,
            description: 'Hot baked pretzel with sesame seeds',
            ingredients: ['Flour', 'Water', 'Yeast', 'Salt', 'Sesame seeds'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Boiled then baked',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/BrezelnSalz02.JPG'
          }
        ]
      }
    ]
  },
  'SOFIA': {
    standName: 'Sofia Banitsa Window',
    standIcon: 'ChefHat',
    cuisine: 'Bulgarian',
    quests: [
      {
        id: 'sof_banitsa',
        name: 'The Morning Banitsa',
        description: 'Flaky filo pastry filled with Bulgarian white cheese. Best with Ayran!',
        location: 'Vitosha Boulevard',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'banitsa_main',
            name: 'Classic Sofia Banitsa',
            emoji: '🥐',
            calories: 320,
            protein: 10,
            carbs: 28,
            fat: 18,
            description: 'Filo pastry layers with sirene cheese and eggs',
            ingredients: ['Filo dough', 'Sirene (Bulgarian white cheese)', 'Eggs', 'Yogurt', 'Butter'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'BELGRADE': {
    standName: 'Belgrade Pljeskavica Grill',
    standIcon: 'Star',
    cuisine: 'Serbian',
    quests: [
      {
        id: 'beg_pljeskavica',
        name: 'The Serbian Burger',
        description: 'Massive spiced meat patty served in a flatbread (lepinja) with kajmak.',
        location: 'Knez Mihailova',
        reward: 38000,
        fanReward: 11000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'pljeskavica_main',
            name: 'Belgrade Pljeskavica',
            emoji: '🍔',
            calories: 650,
            protein: 42,
            carbs: 38,
            fat: 35,
            description: 'Spiced meat patty in lepinja bread with kajmak and onions',
            ingredients: ['Mixed minced meat', 'Lepinja bread', 'Kajmak (clotted cream)', 'Onions'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/e/e9/Alb%C3%B3ndigas_%28Tapas%29.jpg'
          }
        ]
      }
    ]
  },
  'BUDAPEST': {
    standName: 'Budapest Lángos Truck',
    standIcon: 'Utensils',
    cuisine: 'Hungarian',
    quests: [
      {
        id: 'bud_langos',
        name: 'The Garlic & Cheese Dream',
        description: 'Deep-fried flatbread rubbed with garlic and topped with sour cream and cheese.',
        location: 'Central Market Hall',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'langos_main',
            name: 'Traditional Lángos',
            emoji: '🥯',
            calories: 520,
            protein: 12,
            carbs: 48,
            fat: 32,
            description: 'Fried flatbread with garlic, sour cream, and grated cheese',
            ingredients: ['Flour dough', 'Garlic', 'Sour cream', 'Grated cheese'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Goulash_hungarian.jpg'
          }
        ]
      }
    ]
  },
  'VIENNA': {
    standName: 'Vienna Würstelstand',
    standIcon: 'Star',
    cuisine: 'Austrian',
    quests: [
      {
        id: 'vie_kasekrainer',
        name: 'The Käsekrainer Classic',
        description: 'Sausage filled with cubes of cheese. Watch out for the hot cheese spray!',
        location: 'Albertinaplatz',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'vienna_kasekrainer_1',
            name: 'Austrian Käsekrainer',
            emoji: '🌭',
            calories: 450,
            protein: 22,
            carbs: 5,
            fat: 38,
            description: 'Grilled pork sausage with embedded cheese chunks',
            ingredients: ['Pork sausage', 'Emmental cheese', 'Mustard', 'Horseradish', 'Dark bread'],
            allergens: ['Dairy'],
            cookingMethod: 'Grilled',
            image: 'https://upload.wikimedia.org/wikipedia/commons/1/19/Bratwurst_2.jpg'
          }
        ]
      }
    ]
  },
  'ISTANBUL': {
    standName: 'Istanbul Simit Cart',
    standIcon: 'ChefHat',
    cuisine: 'Turkish',
    quests: [
      {
        id: 'ist_simit',
        name: 'The Simit Circle',
        description: 'Circular bread crusted with sesame seeds. The king of Istanbul street food!',
        location: 'Galata Bridge',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'turkish_simit_1',
            name: 'Istanbul Sesame Simit',
            emoji: '🥨',
            calories: 250,
            protein: 8,
            carbs: 48,
            fat: 4,
            description: 'Molasses-dipped bread ring with toasted sesame seeds',
            ingredients: ['Flour', 'Water', 'Yeast', 'Grape molasses', 'Sesame seeds'],
            allergens: ['Wheat', 'Sesame'],
            cookingMethod: 'Stone baked',
          }
        ]
      }
    ]
  },
  'YEREVAN': {
    standName: 'Yerevan Lahmajoun Shop',
    standIcon: 'Heart',
    cuisine: 'Armenian',
    quests: [
      {
        id: 'evn_lahmajoun',
        name: 'The Armenian Pizza',
        description: 'Thin, crispy flatbread topped with minced meat, herbs, and lemon juice.',
        location: 'Republic Square',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'armenian_lahmajoun_1',
            name: 'Yerevan Special Lahmajoun',
            emoji: '🫓',
            calories: 210,
            protein: 12,
            carbs: 24,
            fat: 8,
            description: 'Thin dough topped with minced beef, parsley, and spices',
            ingredients: ['Dough', 'Minced beef', 'Tomato paste', 'Parsley', 'Lemon'],
            allergens: ['Wheat'],
            cookingMethod: 'Stone baked',
          }
        ]
      }
    ]
  },
  'TBILISI': {
    standName: 'Tbilisi Khachapuri Window',
    standIcon: 'Star',
    cuisine: 'Georgian',
    quests: [
      {
        id: 'tbs_khachapuri',
        name: 'The Boat of Cheese',
        description: 'Ajaruli Khachapuri: boat-shaped bread filled with cheese, butter, and a raw egg!',
        location: 'Old Tbilisi',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'georgian_khachapuri_1',
            name: 'Ajaruli Khachapuri',
            emoji: '🛶',
            calories: 850,
            protein: 32,
            carbs: 75,
            fat: 48,
            description: 'Boat-shaped bread with melted Sulguni cheese and an egg',
            ingredients: ['Yeast dough', 'Sulguni cheese', 'Egg', 'Butter'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'SKOPJE': {
    standName: 'Skopje Kebapi Corner',
    standIcon: 'Utensils',
    cuisine: 'Macedonian',
    quests: [
      {
        id: 'skp_kebapi',
        name: 'The Old Bazaar Ten',
        description: 'Ten perfectly grilled kebapi served with onions and fresh bread.',
        location: 'Old Bazaar',
        reward: 33000,
        fanReward: 9000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'macedonian_kebapi_1',
            name: 'Skopje Beef Kebapi',
            emoji: '🍢',
            calories: 420,
            protein: 38,
            carbs: 22,
            fat: 24,
            description: 'Grilled minced meat sausages served with onions and lepinja',
            ingredients: ['Beef', 'Garlic', 'Salt', 'Black pepper', 'Lepinja bread'],
            allergens: ['Wheat'],
            cookingMethod: 'Charcoal grilled',
          }
        ]
      }
    ]
  },
  'LJUBLJANA': {
    standName: 'Ljubljana Kremsnita Stall',
    standIcon: 'Cookie',
    cuisine: 'Slovenian',
    quests: [
      {
        id: 'lju_kremsnita',
        name: 'The Vanilla Cloud',
        description: 'Traditional Bled-style cream cake. Light, airy, and delicately sweet!',
        location: 'Prešeren Square',
        reward: 34000,
        fanReward: 9500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'slovenian_kremsnita_1',
            name: 'Ljubljana Cream Cake',
            emoji: '🍰',
            calories: 380,
            protein: 6,
            carbs: 45,
            fat: 22,
            description: 'Puff pastry with vanilla custard and whipped cream',
            ingredients: ['Puff pastry', 'Vanilla custard', 'Whipped cream', 'Icing sugar'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Assembled',
          }
        ]
      }
    ]
  },
  'ZAGREB': {
    standName: 'Zagreb Štrukli Spot',
    standIcon: 'ChefHat',
    cuisine: 'Croatian',
    quests: [
      {
        id: 'zag_strukli',
        name: 'The Heart of Zagorje',
        description: 'Dough filled with cottage cheese, then boiled and baked. Pure comfort!',
        location: 'Dolac Market',
        reward: 36000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'croatian_strukli_1',
            name: 'Zagreb Cheese Štrukli',
            emoji: '🥟',
            calories: 420,
            protein: 18,
            carbs: 38,
            fat: 24,
            description: 'Traditional dough with cottage cheese and sour cream',
            ingredients: ['Dough', 'Cottage cheese', 'Sour cream', 'Eggs', 'Butter'],
            allergens: ['Wheat', 'Dairy', 'Eggs'],
            cookingMethod: 'Boiled then baked',
          }
        ]
      }
    ]
  },
  'TIRANA': {
    standName: 'Tirana Byrek Window',
    standIcon: 'Utensils',
    cuisine: 'Albanian',
    quests: [
      {
        id: 'tia_byrek',
        name: 'The Spinach Byrek',
        description: 'Savory phyllo pie with spinach and feta cheese. An Albanian street food icon!',
        location: 'Skanderbeg Square',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'albanian_byrek_1',
            name: 'Tirana Spinach Byrek',
            emoji: '🥧',
            calories: 290,
            protein: 8,
            carbs: 26,
            fat: 16,
            description: 'Phyllo pastry layers filled with spinach and Albanian cottage cheese',
            ingredients: ['Phyllo dough', 'Spinach', 'Gjizë (cottage cheese)', 'Onions'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'SARAJEVO': {
    standName: 'Sarajevo Ćevapi Home',
    standIcon: 'Star',
    cuisine: 'Bosnian',
    quests: [
      {
        id: 'sjj_cevapi',
        name: 'The Baščaršija Five',
        description: 'Legendary Bosnian ćevapi served in somun bread with raw onions and kajmak.',
        location: 'Baščaršija',
        reward: 40000,
        fanReward: 12000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'bosnian_cevapi_1',
            name: 'Sarajevo Special Ćevapi',
            emoji: '🍢',
            calories: 550,
            protein: 45,
            carbs: 35,
            fat: 32,
            description: 'Mixed meat sausages in somun bread with onions',
            ingredients: ['Beef & Lamb mix', 'Somun bread', 'Onions', 'Kajmak'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Charcoal grilled',
          }
        ]
      }
    ]
  },
  'PODGORICA': {
    standName: 'Podgorica Burek Shed',
    standIcon: 'Utensils',
    cuisine: 'Montenegrin',
    quests: [
      {
        id: 'tgd_burek',
        name: 'The Spiral Pie',
        description: 'Crispy spiral dough filled with meat or cheese. Best enjoyed with yogurt!',
        location: 'Njegoševa Street',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'montenegrin_burek_1',
            name: 'Podgorica Meat Burek',
            emoji: '🥧',
            calories: 450,
            protein: 16,
            carbs: 38,
            fat: 26,
            description: 'Spiral phyllo pastry filled with seasoned minced meat',
            ingredients: ['Phyllo dough', 'Minced beef', 'Onions', 'Black pepper'],
            allergens: ['Wheat'],
            cookingMethod: 'Oven baked',
          }
        ]
      }
    ]
  },
  'PRISTINA': {
    standName: 'Pristina Flia Hut',
    standIcon: 'ChefHat',
    cuisine: 'Kosovar',
    quests: [
      {
        id: 'prn_flia',
        name: 'The Layered Masterpiece',
        description: 'Multiple layers of thin batter cooked under a "saç" (metal lid). A true labor of love!',
        location: 'Mother Teresa Boulevard',
        reward: 45000,
        fanReward: 13000,
        difficulty: 'HARD',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kosovar_flia_1',
            name: 'Pristina Traditional Flia',
            emoji: '🥞',
            calories: 620,
            protein: 14,
            carbs: 65,
            fat: 32,
            description: 'Many layers of batter with cream and butter in between',
            ingredients: ['Flour', 'Water', 'Salt', 'Kaymak', 'Butter'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Layer by layer under saç',
          }
        ]
      }
    ]
  },
  'CHISINAU': {
    standName: 'Chisinau Plăcintă Point',
    standIcon: 'Heart',
    cuisine: 'Moldovan',
    quests: [
      {
        id: 'kiv_placinta',
        name: 'The Moldovan Pie',
        description: 'Traditional round flat pies filled with cheese, pumpkin, or cabbage.',
        location: 'Stefan cel Mare',
        reward: 31000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'moldovan_placinta_1',
            name: 'Chisinau Cheese Plăcintă',
            emoji: '🥧',
            calories: 280,
            protein: 12,
            carbs: 32,
            fat: 12,
            description: 'Fried dough with branza (sheep cheese) and herbs',
            ingredients: ['Dough', 'Sheep cheese (Branza)', 'Dill', 'Spring onions'],
            allergens: ['Wheat', 'Dairy'],
            cookingMethod: 'Pan fried',
          }
        ]
      }
    ]
  },
  'PHNOM_PENH': {
    standName: 'Phnom Penh Noodle Stall',
    standIcon: 'Utensils',
    cuisine: 'Cambodian',
    quests: [
      {
        id: 'phnom_penh_noodles',
        name: 'Kuy Teav Adventure',
        description: 'Traditional Cambodian rice noodle soup with pork and herbs. A breakfast staple!',
        location: 'Central Market',
        reward: 32000,
        fanReward: 9000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'kuy_teav_main',
            name: 'Kuy Teav Phnom Penh',
            emoji: '🍜',
            calories: 280,
            protein: 12,
            carbs: 45,
            fat: 8,
            description: 'Rice noodles in pork broth with herbs, bean sprouts, and lime.',
            ingredients: ['Rice noodles', 'Pork broth', 'Bean sprouts', 'Green onions', 'Lime', 'Garlic'],
            allergens: ['Pork', 'Soy'],
            cookingMethod: 'Simmered broth',
            image: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Kuy_teav.jpg'
          }
        ]
      }
    ]
  },
  'VIENTIANE': {
    standName: 'Vientiane River Market',
    standIcon: 'ChefHat',
    cuisine: 'Laotian',
    quests: [
      {
        id: 'vientiane_sticky_rice',
        name: 'Khao Niao Sticky Rice',
        description: 'Sweet sticky rice with coconut milk, served in bamboo. Perfect afternoon snack!',
        location: 'Mekong Riverbank',
        reward: 28000,
        fanReward: 8000,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'khao_niao_main',
            name: 'Khao Niao Mamuang',
            emoji: '🍘',
            calories: 220,
            protein: 4,
            carbs: 48,
            fat: 6,
            description: 'Glutinous rice with coconut milk and fresh mango, served in bamboo tubes.',
            ingredients: ['Glutinous rice', 'Coconut milk', 'Mango', 'Sugar', 'Salt', 'Bamboo'],
            allergens: [],
            cookingMethod: 'Steamed in bamboo',
            image: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Khao_niao_mamuang.jpg'
          }
        ]
      }
    ]
  },
  'KINGSTON': {
    standName: 'Kingston Jerk Center',
    standIcon: 'Heart',
    cuisine: 'Jamaican',
    quests: [
      {
        id: 'kingston_jerk_chicken',
        name: 'Jerk Chicken Challenge',
        description: 'Spicy grilled chicken with Scotch bonnet peppers. The authentic Jamaican experience!',
        location: 'Devon House',
        reward: 35000,
        fanReward: 10000,
        difficulty: 'MEDIUM',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'jerk_chicken_main',
            name: 'Authentic Jerk Chicken',
            emoji: '🍗',
            calories: 320,
            protein: 28,
            carbs: 12,
            fat: 18,
            description: 'Chicken marinated in jerk spices and grilled over pimento wood.',
            ingredients: ['Chicken', 'Scotch bonnet peppers', 'Allspice', 'Thyme', 'Garlic', 'Onions', 'Pimento wood'],
            allergens: [],
            cookingMethod: 'Grilled over pimento wood',
            image: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Jerk_chicken_with_rice_and_peas.jpg'
          }
        ]
      }
    ]
  },
  'NASSAU': {
    standName: 'Nassau Conch Fritters',
    standIcon: 'Star',
    cuisine: 'Bahamian',
    quests: [
      {
        id: 'nassau_conch_fritters',
        name: 'Conch Fritters Feast',
        description: 'Fresh conch fritters with spicy dipping sauce. A taste of the Bahamas!',
        location: 'Arawak Cay',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: [
          {
            id: 'conch_fritters_main',
            name: 'Bahamian Conch Fritters',
            emoji: '🦪',
            calories: 180,
            protein: 8,
            carbs: 15,
            fat: 10,
            description: 'Deep-fried conch meat with peppers, onions, and spices, served with hot sauce.',
            ingredients: ['Conch meat', 'Flour', 'Eggs', 'Bell peppers', 'Onions', 'Hot peppers', 'Spices'],
            allergens: ['Shellfish', 'Gluten', 'Eggs'],
            cookingMethod: 'Deep fried',
            image: 'https://upload.wikimedia.org/wikipedia/commons/7/7a/Conch_fritters.jpg'
          }
        ]
      }
    ]
  },
  'DEFAULT': {
    standName: 'Street Food Stand',
    standIcon: 'Utensils',
    cuisine: 'Local',
    quests: [
      {
        id: 'local_food_discovery',
        name: 'Local Street Food Discovery',
        description: 'Explore the local street food scene and find hidden gems. Every city has its specialties!',
        location: 'Local Markets',
        reward: 30000,
        fanReward: 8500,
        difficulty: 'EASY',
        requirements: [],
        completed: false,
        foodItems: []
      }
    ]
  }
};
